import { __awaiter, __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, Component, Input, ViewChild, EventEmitter, Output, ViewEncapsulation, NgModule } from '@angular/core';
import { createFeatureSelector, createSelector, select, Store, StoreModule } from '@ngrx/store';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormControl, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { map, first, take, concatMap, catchError } from 'rxjs/operators';
import { createEntityAdapter } from '@ngrx/entity';
import { environment } from '@blue/services';
import { TotalBalanceCondition, ApplicationType, AccountService, TrialBalanceService, FiscalYearService, PeriodType, PeriodService, AccountTagService, AccountGroupService, TaxScheduleService, TaxCodeService, CategoryNodeService, AccountingServicesModule } from '@accounting/accounting-services';
import { has } from '@blue/services/permission';
import { ofType, Actions, Effect, EffectsModule } from '@ngrx/effects';
import { of } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { BentoModule } from '@bento/bento-ng';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ngrx/store';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';
import * as ɵngcc5 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc6 from '@bento/bento-ng';
import * as ɵngcc7 from '@accounting/accounting-services';
import * as ɵngcc8 from '@ngrx/effects';

const _c0 = ["accountNumberInput"];
function AccountNumberFormComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(1, 1, "bmaa_common_validCharacters"));
} }
function AccountNumberFormComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(1, 1, "bmaa_common_duplicateAccountNumber"));
} }
const _c1 = function (a0) { return { "has-error": a0 }; };
const _c2 = ["accountNumberComponent"];
function AddAccountModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "bmaa_common_addEquityAccount"), " ");
} }
function AddAccountModalComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "bmaa_common_addAccount"), " ");
} }
function AddAccountModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "div", 21);
    ɵngcc0.ɵɵelement(2, "span", 22);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(3, 1, "bmaa_common_numberDescriptionRequired"));
} }
function AddAccountModalComponent_bmaa_round_independently_form_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-round-independently-form", 10);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("addEditAccountForm", ctx_r6.addAccountForm);
} }
function AddAccountModalComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "span", 23);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(2, 1, "bmaa_common_groupingAssignments"));
} }
function AddAccountModalComponent_bmaa_account_grouping_form_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-account-grouping-form", 24);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("schedule", ctx_r8.accountClassificationSchedule)("modalBodyReference", _r3)("optionsObservable", ctx_r8.getCategoryNodeOptionsForSchedule(ctx_r8.accountClassificationSchedule == null ? null : ctx_r8.accountClassificationSchedule.id))("addEditAccountForm", ctx_r8.addAccountForm)("balanceOptionFormControlName", ctx_r8.bmaaFormStrings.ACCOUNT_CLASSFICATION_BALANCE_OPTION_COMBOBOX_CONTROL)("totalBalanceComboboxControlName", ctx_r8.bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL)("debitComboboxControlName", ctx_r8.bmaaFormStrings.ACCOUNT_CLASSFICATION_DEBIT_COMBOBOX_CONTROL)("creditComboboxControlName", ctx_r8.bmaaFormStrings.ACCOUNT_CLASSFICATION_CREDIT_COMBOBOX_CONTROL);
} }
function AddAccountModalComponent_bmaa_account_grouping_form_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-account-grouping-form", 24);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("schedule", ctx_r9.taxSchedule)("modalBodyReference", _r3)("optionsObservable", ctx_r9.taxCodeOptionComboboxObservable)("addEditAccountForm", ctx_r9.addAccountForm)("balanceOptionFormControlName", ctx_r9.bmaaFormStrings.TAX_SCHEDULE_BALANCE_OPTION_COMBOBOX_CONTROL)("totalBalanceComboboxControlName", ctx_r9.bmaaFormStrings.TAX_CODE_COMBOBOX_CONTROL)("debitComboboxControlName", ctx_r9.bmaaFormStrings.TAX_CODE_DEBIT_COMBOBOX_CONTROL)("creditComboboxControlName", ctx_r9.bmaaFormStrings.TAX_CODE_CREDIT_COMBOBOX_CONTROL);
} }
function AddAccountModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "bmaa-account-grouping-form", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const schedule_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("schedule", schedule_r11)("modalBodyReference", _r3)("optionsObservable", ctx_r10.getCategoryNodeOptionsForSchedule(schedule_r11.id))("addEditAccountForm", ctx_r10.addAccountForm)("balanceOptionFormControlName", ctx_r10.bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule_r11.id))("totalBalanceComboboxControlName", ctx_r10.bmaaFormStrings.getUserDefinedControl(schedule_r11.id))("debitComboboxControlName", ctx_r10.bmaaFormStrings.getUserDefinedDebitControl(schedule_r11.id))("creditComboboxControlName", ctx_r10.bmaaFormStrings.getUserDefinedCreditControl(schedule_r11.id));
} }
function EditAccountModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11)(1, "div", 18);
    ɵngcc0.ɵɵelement(2, "span", 19);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(3, 1, "bmaa_common_numberDescriptionRequired"));
} }
function EditAccountModalComponent_bmaa_round_independently_form_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-round-independently-form", 20);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("isEditModal", true)("addEditAccountForm", ctx_r2.editAccountForm);
} }
function EditAccountModalComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelement(1, "span", 21);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(2, 1, "bmaa_common_groupingAssignments"));
} }
function EditAccountModalComponent_bmaa_account_grouping_form_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-account-grouping-form", 22);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("schedule", ctx_r4.accountClassificationSchedule)("modalBodyReference", _r0)("optionsObservable", ctx_r4.getCategoryNodeOptionsForSchedule(ctx_r4.accountClassificationSchedule == null ? null : ctx_r4.accountClassificationSchedule.id))("addEditAccountForm", ctx_r4.editAccountForm)("balanceOptionFormControlName", ctx_r4.bmaaFormStrings.ACCOUNT_CLASSFICATION_BALANCE_OPTION_COMBOBOX_CONTROL)("totalBalanceComboboxControlName", ctx_r4.bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL)("debitComboboxControlName", ctx_r4.bmaaFormStrings.ACCOUNT_CLASSFICATION_DEBIT_COMBOBOX_CONTROL)("creditComboboxControlName", ctx_r4.bmaaFormStrings.ACCOUNT_CLASSFICATION_CREDIT_COMBOBOX_CONTROL);
} }
function EditAccountModalComponent_bmaa_account_grouping_form_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "bmaa-account-grouping-form", 22);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵproperty("schedule", ctx_r5.taxSchedule)("modalBodyReference", _r0)("optionsObservable", ctx_r5.taxCodeOptionComboboxObservable)("addEditAccountForm", ctx_r5.editAccountForm)("balanceOptionFormControlName", ctx_r5.bmaaFormStrings.TAX_SCHEDULE_BALANCE_OPTION_COMBOBOX_CONTROL)("totalBalanceComboboxControlName", ctx_r5.bmaaFormStrings.TAX_CODE_COMBOBOX_CONTROL)("debitComboboxControlName", ctx_r5.bmaaFormStrings.TAX_CODE_DEBIT_COMBOBOX_CONTROL)("creditComboboxControlName", ctx_r5.bmaaFormStrings.TAX_CODE_CREDIT_COMBOBOX_CONTROL);
} }
function EditAccountModalComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "bmaa-account-grouping-form", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const schedule_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("schedule", schedule_r7)("modalBodyReference", _r0)("optionsObservable", ctx_r6.getCategoryNodeOptionsForSchedule(schedule_r7.id))("addEditAccountForm", ctx_r6.editAccountForm)("balanceOptionFormControlName", ctx_r6.bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule_r7.id))("totalBalanceComboboxControlName", ctx_r6.bmaaFormStrings.getUserDefinedControl(schedule_r7.id))("debitComboboxControlName", ctx_r6.bmaaFormStrings.getUserDefinedDebitControl(schedule_r7.id))("creditComboboxControlName", ctx_r6.bmaaFormStrings.getUserDefinedCreditControl(schedule_r7.id));
} }
function AccountGroupingFormComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "bmaa_addEditAccount_categoryStructure"));
} }
function AccountGroupingFormComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 3)(2, "div", 4)(3, "input", 5);
    ɵngcc0.ɵɵlistener("click", function AccountGroupingFormComponent_div_4_Template_input_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.balanceOptionChanged(ctx_r6.bmaaBalanceOption.TotalBalance); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 6);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(7, "div", 4)(8, "input", 7);
    ɵngcc0.ɵɵlistener("click", function AccountGroupingFormComponent_div_4_Template_input_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.balanceOptionChanged(ctx_r8.bmaaBalanceOption.DebitCredit); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "label", 8);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "bmaa-total-balance-", ctx_r1.schedule.id, "");
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r1.balanceOptionFormControlName);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.option.always." + (ctx_r1.schedule == null ? null : ctx_r1.schedule.id));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 9, "bmaa_total_balance"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "bmaa-debit-credit-", ctx_r1.schedule.id, "");
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r1.balanceOptionFormControlName);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.option.debitCredit." + (ctx_r1.schedule == null ? null : ctx_r1.schedule.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("for", "bmaa-debit-credit-", ctx_r1.schedule.id, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(11, 11, "bmaa_assign_debit_credit"), " ");
} }
function AccountGroupingFormComponent_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(1, 1, "bmaa_common_accountClassRequired"));
} }
function AccountGroupingFormComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "bento-combobox", 9);
    ɵngcc0.ɵɵtemplate(2, AccountGroupingFormComponent_div_5_div_2_Template, 2, 3, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r2.totalBalanceComboboxControlName);
    ɵngcc0.ɵɵproperty("required", ctx_r2.schedule.isStandardAccountClassification && ctx_r2.defaultFirstGrouping)("appendTo", ctx_r2.modalBodyReference)("options", ctx_r2.categoryNodeOptionsComboboxOptions)("placeholder", false)("itemsObservable", ctx_r2.optionsObservable)("rowTemplate", _r4);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.combo.always." + (ctx_r2.schedule == null ? null : ctx_r2.schedule.id));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.schedule.isStandardAccountClassification && ctx_r2.addEditAccountForm.get(ctx_r2.bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).touched && ctx_r2.addEditAccountForm.get(ctx_r2.bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).hasError(ctx_r2.bmaaFormStrings.REQUIRED_ERROR));
} }
function AccountGroupingFormComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "table", 12)(2, "thead")(3, "tr")(4, "th")(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(8, "th")(9, "span");
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd()()()();
    ɵngcc0.ɵɵelementStart(12, "tbody")(13, "tr")(14, "td");
    ɵngcc0.ɵɵelement(15, "bento-combobox", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "td");
    ɵngcc0.ɵɵelement(17, "bento-combobox", 13);
    ɵngcc0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 16, "bmaa_debit"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 18, "bmaa_credit"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r3.debitComboboxControlName);
    ɵngcc0.ɵɵproperty("appendTo", ctx_r3.modalBodyReference)("options", ctx_r3.categoryNodeOptionsComboboxOptions)("placeholder", false)("itemsObservable", ctx_r3.optionsObservable)("rowTemplate", _r4);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.combo.debit." + (ctx_r3.schedule == null ? null : ctx_r3.schedule.id));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx_r3.creditComboboxControlName);
    ɵngcc0.ɵɵproperty("appendTo", ctx_r3.modalBodyReference)("options", ctx_r3.categoryNodeOptionsComboboxOptions)("placeholder", false)("itemsObservable", ctx_r3.optionsObservable)("rowTemplate", _r4);
    ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.combo.credit." + (ctx_r3.schedule == null ? null : ctx_r3.schedule.id));
} }
function AccountGroupingFormComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const $data_r10 = ctx.data;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", $data_r10.row.codeOption + " | " + $data_r10.row.description, " ");
} }
function AccountDescriptionFormComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 4);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    ɵngcc0.ɵɵpropertyInterpolate("translate", ɵngcc0.ɵɵpipeBind1(1, 1, "bmaa_common_duplicateAccountDescription"));
} }
const _c3 = ["roundIndependentlyInput"];
function RoundIndependentlyFormComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "span", 8);
    ɵngcc0.ɵɵtext(2, "Warning");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, "bmaa_roundIndependently_msg"));
} }
var AccountActionTypes;
(function (AccountActionTypes) {
    AccountActionTypes["LoadAccounts"] = "[BMAA Account] Load Accounts";
    AccountActionTypes["LoadAccountsSuccess"] = "[BMAA Account] Load Accounts Success";
    AccountActionTypes["LoadAccountsFailure"] = "[BMAA Account] Load Accounts Failure";
    AccountActionTypes["SetAccounts"] = "[BMAA Account] Set Accounts";
    AccountActionTypes["AddNewAccount"] = "[BMAA Account] Add New Account";
    AccountActionTypes["UpdateAccount"] = "[BMAA Account] Update Account";
})(AccountActionTypes || (AccountActionTypes = {}));
// To load accounts connected to ownerId
class LoadAccounts {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.LoadAccounts;
    }
}
// When accounts, sent in data property, successfully loaded
class LoadAccountsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.LoadAccountsSuccess;
    }
}
// Loading of accounts failed
class LoadAccountsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.LoadAccountsFailure;
    }
}
// Set the accounts in the store
class SetAccounts {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.SetAccounts;
    }
}
// Save down a newly added accuont
class AddNewAccount {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.AddNewAccount;
    }
}
// Save down a newly added accuont
class UpdateAccount {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountActionTypes.UpdateAccount;
    }
}

const initialState = {
    accounts: [],
    accountsLoading: false,
    accountsLoaded: false,
    accountsLoadingFailed: false
};
// Updates the state based on the action and its payload
function reducer(state = initialState, action) {
    switch (action.type) {
        case AccountActionTypes.LoadAccounts:
            return Object.assign(Object.assign({}, state), { accountsLoading: true, accountsLoaded: false, accountsLoadingFailed: false });
        case AccountActionTypes.LoadAccountsSuccess:
            return Object.assign(Object.assign({}, state), { accounts: action.payload.data, accountsLoaded: true, accountsLoading: false, accountsLoadingFailed: false });
        case AccountActionTypes.LoadAccountsFailure:
            return Object.assign(Object.assign({}, state), { accountsLoadingFailed: true, accountsLoading: false, accountsLoaded: false });
        case AccountActionTypes.SetAccounts:
            return Object.assign(Object.assign({}, state), { accounts: action.payload.accounts, accountsLoaded: true, accountsLoadingFailed: false, accountsLoading: false });
        case AccountActionTypes.AddNewAccount:
            return Object.assign(Object.assign({}, state), { accounts: [...state.accounts, action.payload.newAccount] });
        case AccountActionTypes.UpdateAccount:
            const indexOfAccount = state.accounts.findIndex(account => account.id === action.payload.updatedAccount.id);
            return Object.assign(Object.assign({}, state), { accounts: state.accounts.map((account, index) => {
                    return index !== indexOfAccount ? account : action.payload.updatedAccount;
                }) });
        default:
            return state;
    }
}

var AccountGroupActionTypes;
(function (AccountGroupActionTypes) {
    AccountGroupActionTypes["LoadAccountGroups"] = "[BMAA AccountGroup] Load AccountGroups";
    AccountGroupActionTypes["LoadAccountGroupsSuccess"] = "[BMAA AccountGroup] Load AccountGroups Success";
    AccountGroupActionTypes["LoadAccountGroupsFailure"] = "[BMAA AccountGroup] Load AccountGroups Failure";
    AccountGroupActionTypes["SetAccountGroups"] = "[BMAA AccountGroup] Set AccountGroups";
})(AccountGroupActionTypes || (AccountGroupActionTypes = {}));
// Loads the accountGroups for ownerId
class LoadAccountGroups {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroups;
    }
}
// When accountGroups are successfully loaded sent in data
class LoadAccountGroupsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroupsSuccess;
    }
}
// When accountGroups fail to load
class LoadAccountGroupsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.LoadAccountGroupsFailure;
    }
}
// Set existing accountGroups into the store
class SetAccountGroups {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountGroupActionTypes.SetAccountGroups;
    }
}

const initialState$1 = {
    accountGroups: [],
    accountGroupsLoading: false,
    accountGroupsLoaded: false,
    accountGroupsLoadingFailed: false
};
// Updates the accountGroupState based on action
function reducer$1(state = initialState$1, action) {
    switch (action.type) {
        case AccountGroupActionTypes.LoadAccountGroups:
            return Object.assign(Object.assign({}, state), { accountGroupsLoading: true, accountGroupsLoaded: false, accountGroupsLoadingFailed: false });
        case AccountGroupActionTypes.LoadAccountGroupsSuccess:
            return Object.assign(Object.assign({}, state), { accountGroups: action.payload.data, accountGroupsLoaded: true, accountGroupsLoading: false, accountGroupsLoadingFailed: false });
        case AccountGroupActionTypes.LoadAccountGroupsFailure:
            return Object.assign(Object.assign({}, state), { accountGroupsLoaded: false, accountGroupsLoading: false, accountGroupsLoadingFailed: true });
        case AccountGroupActionTypes.SetAccountGroups:
            return Object.assign(Object.assign({}, state), { accountGroups: action.payload.accountGroups, accountGroupsLoaded: true, accountGroupsLoading: false, accountGroupsLoadingFailed: false });
        default:
            return state;
    }
}

var TaxScheduleActionTypes;
(function (TaxScheduleActionTypes) {
    TaxScheduleActionTypes["LoadTaxSchedules"] = "[BMAA TaxSchedule] Load Tax Schedules";
    TaxScheduleActionTypes["LoadTaxSchedulesSuccess"] = "[BMAA TaxSchedule] Load Tax Schedules Success";
    TaxScheduleActionTypes["LoadTaxSchedulesFailure"] = "[BMAA TaxSchedule] Load Tax Schedules Failure";
    TaxScheduleActionTypes["SetTaxSchedule"] = "[BMAA TaxSchedule] Set Tax Schedule";
})(TaxScheduleActionTypes || (TaxScheduleActionTypes = {}));
// Load the tax schedule for ownerId
class LoadTaxSchedules {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxScheduleActionTypes.LoadTaxSchedules;
    }
}
// Successfully loaded the tax schedule, sent in data
class LoadTaxSchedulesSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxScheduleActionTypes.LoadTaxSchedulesSuccess;
    }
}
// Failed to load the tax schedule
class LoadTaxSchedulesFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxScheduleActionTypes.LoadTaxSchedulesFailure;
    }
}
// Set the tax schedule from preexisting data
class SetTaxSchedule {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxScheduleActionTypes.SetTaxSchedule;
    }
}

const initialState$2 = {
    taxSchedule: null,
    taxScheduleLoading: false,
    taxScheduleLoaded: false,
    taxScheduleLoadingFailed: false,
};
// Update TaxScheduleState based on data
function reducer$2(state = initialState$2, action) {
    switch (action.type) {
        case TaxScheduleActionTypes.LoadTaxSchedules:
            return Object.assign(Object.assign({}, state), { taxScheduleLoading: true, taxScheduleLoaded: false, taxScheduleLoadingFailed: false });
        case TaxScheduleActionTypes.LoadTaxSchedulesSuccess:
            return Object.assign(Object.assign({}, state), { taxSchedule: action.payload.data, taxScheduleLoading: false, taxScheduleLoaded: true, taxScheduleLoadingFailed: false });
        case TaxScheduleActionTypes.LoadTaxSchedulesFailure:
            return Object.assign(Object.assign({}, state), { taxScheduleLoaded: false, taxScheduleLoading: false, taxScheduleLoadingFailed: true });
        case TaxScheduleActionTypes.SetTaxSchedule:
            return Object.assign(Object.assign({}, state), { taxSchedule: action.payload.taxSchedule, taxScheduleLoaded: true, taxScheduleLoading: false, taxScheduleLoadingFailed: false });
        default:
            return state;
    }
}

var TaxCodeMappingOptionActionTypes;
(function (TaxCodeMappingOptionActionTypes) {
    TaxCodeMappingOptionActionTypes["LoadTaxCodeMappingOptions"] = "[BMAA TaxCodeMappingOption] Load TaxCodeMappingOptions";
    TaxCodeMappingOptionActionTypes["LoadTaxCodeMappingOptionsSuccess"] = "[BMAA TaxCodeMappingOption] Load TaxCodeMappingOptions Success";
    TaxCodeMappingOptionActionTypes["LoadTaxCodeMappingOptionsFailure"] = "[BMAA TaxCodeMappingOption] Load TaxCodeMappingOptions Failure";
    TaxCodeMappingOptionActionTypes["SetTaxCodeMappingOptions"] = "[BMAA TaxCodeMappingOption] Set TaxCodeMappingOptions";
})(TaxCodeMappingOptionActionTypes || (TaxCodeMappingOptionActionTypes = {}));
// Loads the TaxCodeMappingOptions for taxScheduleId
class LoadTaxCodeMappingOptions {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptions;
    }
}
// Successfully loaded the options for taxScheduleId sent in data
class LoadTaxCodeMappingOptionsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptionsSuccess;
    }
}
// Failed to load the mapping options for the tax schedule
class LoadTaxCodeMappingOptionsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptionsFailure;
    }
}
// Set the mapping options for the tax schedule from preexisting data
class SetTaxCodeMappingOptions {
    constructor(payload) {
        this.payload = payload;
        this.type = TaxCodeMappingOptionActionTypes.SetTaxCodeMappingOptions;
    }
}

const initialState$3 = {
    taxCodeMappingOptions: [],
    taxCodeOptionsLoaded: false,
    taxCodeOptionsLoading: false,
    taxCodeOptionsLoadingFailed: false,
};
// Update the TaxCodeMappingOptionsState based on action
function reducer$3(state = initialState$3, action) {
    switch (action.type) {
        case TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptions:
            return Object.assign(Object.assign({}, state), { taxCodeOptionsLoading: true, taxCodeOptionsLoaded: false, taxCodeOptionsLoadingFailed: false });
        case TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptionsSuccess:
            return Object.assign(Object.assign({}, state), { taxCodeMappingOptions: action.payload.data, taxCodeOptionsLoading: false, taxCodeOptionsLoaded: true, taxCodeOptionsLoadingFailed: false });
        case TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptionsFailure:
            return Object.assign(Object.assign({}, state), { taxCodeOptionsLoaded: false, taxCodeOptionsLoading: false, taxCodeOptionsLoadingFailed: true });
        case TaxCodeMappingOptionActionTypes.SetTaxCodeMappingOptions:
            return Object.assign(Object.assign({}, state), { taxCodeMappingOptions: action.payload.taxCodeOptions, taxCodeOptionsLoaded: true, taxCodeOptionsLoading: false, taxCodeOptionsLoadingFailed: false });
        default:
            return state;
    }
}

var StoreSelectorNames;
(function (StoreSelectorNames) {
    StoreSelectorNames["ADD_ACCOUNT"] = "addAccountState";
    StoreSelectorNames["ACCOUNT"] = "accountState";
    StoreSelectorNames["ACCOUNT_WITH_ACCOUNT_GROUP_LINKS"] = "accountWithAccountGroupLinkState";
    StoreSelectorNames["ACCOUNT_WITH_TAX_SCHEDULE_LINKS"] = "accountWithTaxScheduleLinkState";
    StoreSelectorNames["ACCOUNT_GROUP"] = "accountGroupState";
    StoreSelectorNames["CATEGORY_NODE"] = "categoryNodeState";
    StoreSelectorNames["CATEGORY_NODE_OPTION"] = "categoryNodeMappingOptionState";
    StoreSelectorNames["TAX_SCHEDULE"] = "taxScheduleState";
    StoreSelectorNames["TAX_CODE"] = "taxCodeState";
    StoreSelectorNames["TAX_CODE_OPTIONS"] = "taxCodeMappingOptionsState";
})(StoreSelectorNames || (StoreSelectorNames = {}));

var CategoryNodeMappingOptionActionTypes;
(function (CategoryNodeMappingOptionActionTypes) {
    CategoryNodeMappingOptionActionTypes["LoadCategoryNodeMappingOptions"] = "[BMAA CategoryNodeMappingOption] Load CategoryNodeMappingOptions";
    CategoryNodeMappingOptionActionTypes["LoadCategoryNodeMappingOptionsSuccess"] = "[BMAA CategoryNodeMappingOption] Load CategoryNodeMappingOptions Success";
    CategoryNodeMappingOptionActionTypes["LoadCategoryNodeMappingOptionsFailure"] = "[BMAA CategoryNodeMappingOption] Load CategoryNodeMappingOptions Failure";
    CategoryNodeMappingOptionActionTypes["SetCategoryNodeMappingOptions"] = "[BMAA CategoryNodeMappingOption] Set CategoryNodeMappingOptions";
})(CategoryNodeMappingOptionActionTypes || (CategoryNodeMappingOptionActionTypes = {}));
// Loads the Category Node Mapping Options for accountGroupId
class LoadCategoryNodeMappingOptions {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptions;
    }
}
// Mapping Options successfully loaded for accountGroupId
class LoadCategoryNodeMappingOptionsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptionsSuccess;
    }
}
// Mapping Options fialed to load for accountGroupId
class LoadCategoryNodeMappingOptionsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptionsFailure;
    }
}
// Set the categoryNodeOptions for accountGroupId from preexisting data
class SetCategoryNodeMappingOptions {
    constructor(payload) {
        this.payload = payload;
        this.type = CategoryNodeMappingOptionActionTypes.SetCategoryNodeMappingOptions;
    }
}

const ɵ0 = option => option.accountGroupId;
const adapter = createEntityAdapter({
    selectId: ɵ0
});
const initialState$4 = adapter.getInitialState();
// Updates CategoryNodeMappingOptionsState based on action
function reducer$4(state = initialState$4, action) {
    switch (action.type) {
        case CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptions:
            return adapter.upsertOne({
                categoryNodeMappingOptions: [],
                categoryNodeMappingOptionsLoaded: false,
                categoryNodeMappingOptionsLoading: true,
                categoryNodeMappingOptionsLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptionsSuccess:
            return adapter.upsertOne({
                categoryNodeMappingOptions: action.payload.data,
                categoryNodeMappingOptionsLoaded: true,
                categoryNodeMappingOptionsLoading: false,
                categoryNodeMappingOptionsLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptionsFailure:
            return adapter.upsertOne({
                categoryNodeMappingOptions: [],
                categoryNodeMappingOptionsLoaded: false,
                categoryNodeMappingOptionsLoading: false,
                categoryNodeMappingOptionsLoadingFailed: true,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case CategoryNodeMappingOptionActionTypes.SetCategoryNodeMappingOptions:
            return adapter.upsertOne({
                categoryNodeMappingOptions: action.payload.categoryNodeOptions,
                categoryNodeMappingOptionsLoaded: true,
                categoryNodeMappingOptionsLoading: false,
                categoryNodeMappingOptionsLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        default:
            return state;
    }
}
// get the selectors
const { selectIds, selectEntities, selectAll, selectTotal, } = adapter.getSelectors();
// select the dictionary of category node option entities
const selectCategoryNodeMap = selectEntities;

var AccountWithAccountGroupLinkActionTypes;
(function (AccountWithAccountGroupLinkActionTypes) {
    AccountWithAccountGroupLinkActionTypes["LoadAccountWithAccountGroupLinks"] = "[BMAA AccountWithAccountGroupLink] Load AccountWithAccountGroupLinks";
    AccountWithAccountGroupLinkActionTypes["LoadAccountWithAccountGroupLinksSuccess"] = "[BMAA AccountWithAccountGroupLink] Load AccountWithAccountGroupLinks Success";
    AccountWithAccountGroupLinkActionTypes["LoadAccountWithAccountGroupLinksFailure"] = "[BMAA AccountWithAccountGroupLink] Load AccountWithAccountGroupLinks Failure";
    AccountWithAccountGroupLinkActionTypes["SetAccountWithAccountGroupLinks"] = "[BMAA AccountWithAccountGroupLink] Set AccountWithAccountGroupLinks";
})(AccountWithAccountGroupLinkActionTypes || (AccountWithAccountGroupLinkActionTypes = {}));
// Load the accounts linked to accountGroup accountGroupId
class LoadAccountWithAccountGroupLinks {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinks;
    }
}
// Successfully loaded the links for accountGroupId, links sent in data
class LoadAccountWithAccountGroupLinksSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinksSuccess;
    }
}
// Loading of links failed
class LoadAccountWithAccountGroupLinksFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinksFailure;
    }
}
// Set preexisting accountLinks in the state
class SetAccountWithAccountGroupLinks {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithAccountGroupLinkActionTypes.SetAccountWithAccountGroupLinks;
    }
}

const ɵ0$1 = option => option.accountGroupId;
const adapter$1 = createEntityAdapter({
    selectId: ɵ0$1
});
const initialState$5 = adapter$1.getInitialState();
// Updates state based on action
function reducer$5(state = initialState$5, action) {
    switch (action.type) {
        case AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinks:
            return adapter$1.upsertOne({
                accountWithAccountGroupLinks: [],
                accountWithAccountGroupLinksLoaded: false,
                accountWithAccountGroupLinksLoading: true,
                accountWithAccountGroupLinksLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinksSuccess:
            return adapter$1.upsertOne({
                accountWithAccountGroupLinks: action.payload.data,
                accountWithAccountGroupLinksLoaded: true,
                accountWithAccountGroupLinksLoading: false,
                accountWithAccountGroupLinksLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinksFailure:
            return adapter$1.upsertOne({
                accountWithAccountGroupLinks: [],
                accountWithAccountGroupLinksLoaded: false,
                accountWithAccountGroupLinksLoading: false,
                accountWithAccountGroupLinksLoadingFailed: true,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        case AccountWithAccountGroupLinkActionTypes.SetAccountWithAccountGroupLinks:
            return adapter$1.upsertOne({
                accountWithAccountGroupLinks: action.payload.accountLinks,
                accountWithAccountGroupLinksLoaded: true,
                accountWithAccountGroupLinksLoading: false,
                accountWithAccountGroupLinksLoadingFailed: false,
                accountGroupId: action.payload.accountGroupId,
            }, state);
        default:
            return state;
    }
}

var AccountWithTaxScheduleLinkActionTypes;
(function (AccountWithTaxScheduleLinkActionTypes) {
    AccountWithTaxScheduleLinkActionTypes["LoadAccountWithTaxScheduleLinks"] = "[BMAA AccountWithTaxScheduleLink] Load AccountWithTaxScheduleLinks";
    AccountWithTaxScheduleLinkActionTypes["LoadAccountWithTaxScheduleLinksSuccess"] = "[BMAA AccountWithTaxScheduleLink] Load AccountWithTaxScheduleLinks Success";
    AccountWithTaxScheduleLinkActionTypes["LoadAccountWithTaxScheduleLinksFailure"] = "[BMAA AccountWithTaxScheduleLink] Load AccountWithTaxScheduleLinks Failure";
    AccountWithTaxScheduleLinkActionTypes["SetAccountWithTaxScheduleLinks"] = "[BMAA AccountWithTaxScheduleLink] Set AccountWithTaxScheduleLinks";
})(AccountWithTaxScheduleLinkActionTypes || (AccountWithTaxScheduleLinkActionTypes = {}));
// Load the accounts linked to taxScheduleId
class LoadAccountWithTaxScheduleLinks {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinks;
    }
}
// Successfully loaded the links for tax schedule, sent in data
class LoadAccountWithTaxScheduleLinksSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinksSuccess;
    }
}
// Failed to load the tax schedule links
class LoadAccountWithTaxScheduleLinksFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinksFailure;
    }
}
// Set the links for the tax schedule with preexisting data
class SetAccountWithTaxScheduleLinks {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountWithTaxScheduleLinkActionTypes.SetAccountWithTaxScheduleLinks;
    }
}

const initialState$6 = {
    accountWithTaxScheduleLinks: [],
    accountWithTaxScheduleLinksLoaded: false,
    accountWithTaxScheduleLinksLoading: false,
    accountWithTaxScheduleLinksLoadingFailed: false
};
// Update AccountWithTaxScheduleLinkState based on action
function reducer$6(state = initialState$6, action) {
    switch (action.type) {
        case AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinks:
            return Object.assign(Object.assign({}, state), { accountWithTaxScheduleLinksLoaded: false, accountWithTaxScheduleLinksLoading: true, accountWithTaxScheduleLinksLoadingFailed: false });
        case AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinksSuccess:
            return Object.assign(Object.assign({}, state), { accountWithTaxScheduleLinks: action.payload.data, accountWithTaxScheduleLinksLoaded: true, accountWithTaxScheduleLinksLoading: false, accountWithTaxScheduleLinksLoadingFailed: false });
        case AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinksFailure:
            return Object.assign(Object.assign({}, state), { accountWithTaxScheduleLinksLoaded: false, accountWithTaxScheduleLinksLoading: false, accountWithTaxScheduleLinksLoadingFailed: true });
        case AccountWithTaxScheduleLinkActionTypes.SetAccountWithTaxScheduleLinks:
            return Object.assign(Object.assign({}, state), { accountWithTaxScheduleLinks: action.payload.accountsWithTaxLinks, accountWithTaxScheduleLinksLoaded: true, accountWithTaxScheduleLinksLoading: false, accountWithTaxScheduleLinksLoadingFailed: false });
        default:
            return state;
    }
}

var AddAccountSettingsActionTypes;
(function (AddAccountSettingsActionTypes) {
    AddAccountSettingsActionTypes["SetAddAccountSettings"] = "[BMAA AddAccountSettings] Set AddAccountSettings";
})(AddAccountSettingsActionTypes || (AddAccountSettingsActionTypes = {}));
// Sets the add account settings taking in the values
class SetAddAccountSettings {
    constructor(payload) {
        this.payload = payload;
        this.type = AddAccountSettingsActionTypes.SetAddAccountSettings;
    }
}

const initialState$7 = {
    defaultFirstGrouping: false,
    allowDebitCredit: false,
    applicationType: undefined,
    ownerId: undefined,
    accountToUpdate: undefined,
    isEquityAccountModal: false,
};
// updates AddAccountSettingState based on action
function reducer$7(state = initialState$7, action) {
    switch (action.type) {
        case AddAccountSettingsActionTypes.SetAddAccountSettings:
            return {
                defaultFirstGrouping: action.payload.defaultFirstGrouping,
                allowDebitCredit: action.payload.allowDebitCredit,
                applicationType: action.payload.applicationType,
                ownerId: action.payload.ownerId,
                accountToUpdate: action.payload.accountToUpdate,
                isEquityAccountModal: action.payload.isEquityAccountModal,
            };
        default:
            return state;
    }
}

var FiscalYearActionTypes;
(function (FiscalYearActionTypes) {
    FiscalYearActionTypes["LoadFiscalYears"] = "[BMAA FiscalYear] Load FiscalYears";
    FiscalYearActionTypes["LoadFiscalYearsSuccess"] = "[BMAA FiscalYear] Load FiscalYears Success";
    FiscalYearActionTypes["LoadFiscalYearsFailure"] = "[BMAA FiscalYear] Load FiscalYears Failure";
    FiscalYearActionTypes["SetFiscalYears"] = "[BMAA FiscalYears] Set FiscalYears";
})(FiscalYearActionTypes || (FiscalYearActionTypes = {}));
class LoadFiscalYears {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYears;
    }
}
class LoadFiscalYearsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsSuccess;
    }
}
class LoadFiscalYearsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.LoadFiscalYearsFailure;
    }
}
class SetFiscalYears {
    constructor(payload) {
        this.payload = payload;
        this.type = FiscalYearActionTypes.SetFiscalYears;
    }
}

const fiscalYearFeatureKey = 'fiscalYearState';
const initialState$8 = {
    fiscalYears: [],
    fiscalYearsLoading: false,
    fiscalYearsLoaded: false,
    fiscalYearsLoadingFailed: false,
};
function reducer$8(state = initialState$8, action) {
    switch (action.type) {
        case FiscalYearActionTypes.LoadFiscalYears:
            return Object.assign(Object.assign({}, state), { fiscalYears: [], fiscalYearsLoading: true, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: false });
        case FiscalYearActionTypes.LoadFiscalYearsSuccess:
            return Object.assign(Object.assign({}, state), { fiscalYears: action.payload.data, fiscalYearsLoading: false, fiscalYearsLoaded: true, fiscalYearsLoadingFailed: false });
        case FiscalYearActionTypes.LoadFiscalYearsFailure:
            return Object.assign(Object.assign({}, state), { fiscalYearsLoading: false, fiscalYearsLoaded: false, fiscalYearsLoadingFailed: true });
        case FiscalYearActionTypes.SetFiscalYears:
            return Object.assign(Object.assign({}, state), { fiscalYears: action.payload.fiscalyears, fiscalYearsLoaded: true, fiscalYearsLoading: false, fiscalYearsLoadingFailed: false });
        default:
            return state;
    }
}

var PeriodActionTypes;
(function (PeriodActionTypes) {
    PeriodActionTypes["LoadPeriods"] = "[BMAA Period] Load Periods";
    PeriodActionTypes["LoadPeriodsSuccess"] = "[BMAA Period] Load Periods Success";
    PeriodActionTypes["LoadPeriodsFailure"] = "[BMAA Period] Load Periods Failure";
    PeriodActionTypes["SetPeriods"] = "[BMAA Period] Set Periods";
})(PeriodActionTypes || (PeriodActionTypes = {}));
class LoadPeriods {
    constructor(payload) {
        this.payload = payload;
        this.type = PeriodActionTypes.LoadPeriods;
    }
}
class LoadPeriodsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = PeriodActionTypes.LoadPeriodsSuccess;
    }
}
class LoadPeriodsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = PeriodActionTypes.LoadPeriodsFailure;
    }
}
class SetPeriods {
    constructor(payload) {
        this.payload = payload;
        this.type = PeriodActionTypes.SetPeriods;
    }
}

const periodFeatureKey = 'periodState';
const initialState$9 = {
    periods: [],
    periodsLoading: false,
    periodsLoaded: false,
    periodsLoadingFailed: false,
};
function reducer$9(state = initialState$9, action) {
    switch (action.type) {
        case PeriodActionTypes.LoadPeriods:
            return Object.assign(Object.assign({}, state), { periodsLoading: true, periodsLoaded: false, periodsLoadingFailed: false });
        case PeriodActionTypes.LoadPeriodsSuccess:
            return {
                periods: action.payload.data,
                periodsLoading: false,
                periodsLoaded: true,
                periodsLoadingFailed: false,
            };
        case PeriodActionTypes.LoadPeriodsFailure:
            return Object.assign(Object.assign({}, state), { periodsLoading: false, periodsLoaded: false, periodsLoadingFailed: true });
        case PeriodActionTypes.SetPeriods:
            return Object.assign(Object.assign({}, state), { periods: action.payload.periods, periodsLoaded: true, periodsLoading: false, periodsLoadingFailed: false });
        default:
            return state;
    }
}

var AccountTagActionTypes;
(function (AccountTagActionTypes) {
    AccountTagActionTypes["LoadAccountTags"] = "[BMAA AccountTag] Load Account Tags";
    AccountTagActionTypes["LoadAccountTagsSuccess"] = "[BMAA AccountTag] Load Account Tags Success";
    AccountTagActionTypes["LoadAccountTagsFailure"] = "[BMAA AccountTag] Load Account Tags Failure";
    AccountTagActionTypes["SetAccountsTags"] = "[BMAA AccountTag] Set Account Tags";
    AccountTagActionTypes["AddAccountTags"] = "[BMAA AccountTag] Add New Account Tags";
    AccountTagActionTypes["UpdateAccountTag"] = "[BMAA AccountTag] Update Account Tag";
    AccountTagActionTypes["DeleteAccountTags"] = "[BMAA AccountTag] Delete Account Tags";
})(AccountTagActionTypes || (AccountTagActionTypes = {}));
// To load accountTags connected to ownerId
class LoadAccountTags {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.LoadAccountTags;
    }
}
// When accountTags, sent in data property, successfully loaded
class LoadAccountTagsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.LoadAccountTagsSuccess;
    }
}
// Loading of accountTags failed
class LoadAccountTagsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.LoadAccountTagsFailure;
    }
}
// Set the accountTags in the store
class SetAccountsTags {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.SetAccountsTags;
    }
}
// Save down a newly added accuontTag
class AddAccountTags {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.AddAccountTags;
    }
}
// Update the accountTag
class UpdateAccountTag {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.UpdateAccountTag;
    }
}
// Delete AccountTags
class DeleteAccountTags {
    constructor(payload) {
        this.payload = payload;
        this.type = AccountTagActionTypes.DeleteAccountTags;
    }
}

const initialState$a = {
    accountTags: [],
    accountTagsLoading: false,
    accountTagsLoaded: false,
    accountTagsLoadingFailed: false
};
// Updates the state based on the action and its payload
function reducer$a(state = initialState$a, action) {
    switch (action.type) {
        case AccountTagActionTypes.LoadAccountTags:
            return Object.assign(Object.assign({}, state), { accountTagsLoading: true, accountTagsLoaded: false, accountTagsLoadingFailed: false });
        case AccountTagActionTypes.LoadAccountTagsSuccess:
            return Object.assign(Object.assign({}, state), { accountTags: action.payload.data, accountTagsLoading: false, accountTagsLoaded: true, accountTagsLoadingFailed: false });
        case AccountTagActionTypes.LoadAccountTagsFailure:
            return Object.assign(Object.assign({}, state), { accountTagsLoading: false, accountTagsLoaded: false, accountTagsLoadingFailed: true });
        case AccountTagActionTypes.SetAccountsTags:
            return Object.assign(Object.assign({}, state), { accountTags: action.payload.accountTags, accountTagsLoading: false, accountTagsLoaded: true, accountTagsLoadingFailed: false });
        default:
            return state;
    }
}

var ResetStoreActionTypes;
(function (ResetStoreActionTypes) {
    ResetStoreActionTypes["ResetStore"] = "[BMAA RESET] Reset Store";
})(ResetStoreActionTypes || (ResetStoreActionTypes = {}));
// Clears the entriety of the state
class ResetStore {
    constructor() {
        this.type = ResetStoreActionTypes.ResetStore;
    }
}

const getAddAccountState = createFeatureSelector(StoreSelectorNames.ADD_ACCOUNT);
const reducers = {
    accountState: reducer,
    accountGroupState: reducer$1,
    taxScheduleState: reducer$2,
    taxCodeMappingOptionState: reducer$3,
    categoryNodeMappingOptionState: reducer$4,
    accountWithAccountGroupLinkState: reducer$5,
    accountWithTaxScheduleLinkState: reducer$6,
    addAccountSettingsState: reducer$7,
    fiscalYearState: reducer$8,
    periodState: reducer$9,
    accountTagState: reducer$a
};
function clearState(reducer) {
    return (state, action) => {
        if (action.type === ResetStoreActionTypes.ResetStore) {
            state = undefined;
        }
        return reducer(state, action);
    };
}
const metaReducers = [clearState];

const ɵ0$2 = (state) => state.accountGroupState;
// Gets the accountGroupState
const getAccountGroupState = createSelector(getAddAccountState, ɵ0$2);
const ɵ1 = (state) => state.accountGroups;
// Gets the accountGroups stored in the state
const getAccountGroups = createSelector(getAccountGroupState, ɵ1);
const ɵ2 = (state) => state.accountGroupsLoading;
// Gets the accountGroupsLoading stored in the state
const getAccountGroupsLoading = createSelector(getAccountGroupState, ɵ2);
const ɵ3 = (state) => state.accountGroupsLoaded;
// Gets the accountGroupsLoaded stored in the state
const getAccountGroupsLoaded = createSelector(getAccountGroupState, ɵ3);
const ɵ4 = (state) => state.accountGroupsLoadingFailed;
// Gets the accountGroupsLoadingFailed stored in the state
const getAccountGroupsLoadingFailed = createSelector(getAccountGroupState, ɵ4);

const ɵ0$3 = (state) => state.taxScheduleState;
// Get the taxScheduleState
const getTaxScheduleState = createSelector(getAddAccountState, ɵ0$3);
const ɵ1$1 = (state) => state.taxSchedule;
// Get the taxSchedule stored in the state
const getTaxSchedule = createSelector(getTaxScheduleState, ɵ1$1);
const ɵ2$1 = (state) => state.taxScheduleLoading;
// Get the taxScheduleLoading stored in the state
const getTaxScheduleLoading = createSelector(getTaxScheduleState, ɵ2$1);
const ɵ3$1 = (state) => state.taxScheduleLoaded;
// Get the taxScheduleLoaded stored in the state
const getTaxScheduleLoaded = createSelector(getTaxScheduleState, ɵ3$1);
const ɵ4$1 = (state) => state.taxScheduleLoadingFailed;
// Get the taxScheduleLoadingFailed stored in the state
const getTaxScheduleLoadingFailed = createSelector(getTaxScheduleState, ɵ4$1);

const ɵ0$4 = (state) => state.addAccountSettingsState;
// Gets the addAccountSettingsState
const getAddAccountSettingState = createSelector(getAddAccountState, ɵ0$4);
const ɵ1$2 = (state) => state.defaultFirstGrouping;
// Gets the defaultFirstGrouping from the state
const getDefaultFirstGrouping = createSelector(getAddAccountSettingState, ɵ1$2);
const ɵ2$2 = (state) => state.allowDebitCredit;
// Gets the allowDebitCredit from the state
const getAllowDebitCredit = createSelector(getAddAccountSettingState, ɵ2$2);
const ɵ3$2 = (state) => state.applicationType;
// Gets the applicationType stored in the state
const getApplicationType = createSelector(getAddAccountSettingState, ɵ3$2);
const ɵ4$2 = (state) => state.ownerId;
// Gets the ownerId stored in the state
const getOwnerId = createSelector(getAddAccountSettingState, ɵ4$2);
const ɵ5 = (state) => state.accountToUpdate;
// Gets the accountToUpdate stored in the state
const getAccountToUpdate = createSelector(getAddAccountSettingState, ɵ5);
const ɵ6 = (state) => state.isEquityAccountModal;
// Gets the isEquityAccountModal stored in the state
const getIsEquityAccountModal = createSelector(getAddAccountSettingState, ɵ6);

const ɵ0$5 = (state) => state.categoryNodeMappingOptionState;
// Get the entire categoryNodeMappingOptionsState
const getCategoryNodeMappingOptionState = createSelector(getAddAccountState, ɵ0$5);
const ɵ1$3 = (state, props) => {
    if (state.entities[props.accountGroupId] !== undefined) {
        return state.entities[props.accountGroupId].categoryNodeMappingOptions;
    }
    else {
        return [];
    }
};
// Get the categoryNodeMappingOptions for accountGroupId
const getCategoryNodeMappingOptions = createSelector(getCategoryNodeMappingOptionState, ɵ1$3);
const ɵ2$3 = (state, props) => state.entities[props.accountGroupId].categoryNodeMappingOptionsLoading;
// Get the categoryNodeMappingOptionsLoading for accountGroupId
const getCategoryNodeMappingOptionsLoading = createSelector(getCategoryNodeMappingOptionState, ɵ2$3);
const ɵ3$3 = (state, props) => state.entities[props.accountGroupId].categoryNodeMappingOptionsLoaded;
// Get the categoryNodeMappingOptionsLoaded for accountGroupId
const getCategoryNodeMappingOptionsLoaded = createSelector(getCategoryNodeMappingOptionState, ɵ3$3);
const ɵ4$3 = (state, props) => state.entities[props.accountGroupId].categoryNodeMappingOptionsLoadingFailed;
// Get the categoryNodeMappingOptionsLoadingFailed for accountGroupId
const getCategoryNodeMappingOptionsLoadingFailed = createSelector(getCategoryNodeMappingOptionState, ɵ4$3);

const ɵ0$6 = (state) => state.taxCodeMappingOptionState;
// Get the taxCodeMappingOptionState
const getTaxCodeMappingOptionState = createSelector(getAddAccountState, ɵ0$6);
const ɵ1$4 = (state) => state.taxCodeMappingOptions;
// Get the taxCodeOptions stored in the state
const getTaxCodeOptions = createSelector(getTaxCodeMappingOptionState, ɵ1$4);
const ɵ2$4 = (state) => state.taxCodeOptionsLoading;
// Get the taxCodeOptionsLoading stored in the state
const getTaxCodeOptionsLoading = createSelector(getTaxCodeMappingOptionState, ɵ2$4);
const ɵ3$4 = (state) => state.taxCodeOptionsLoaded;
// Get the taxCodeOptionsLoaded stored in the state
const getTaxCodeOptionsLoaded = createSelector(getTaxCodeMappingOptionState, ɵ3$4);
const ɵ4$4 = (state) => state.taxCodeOptionsLoadingFailed;
// Get the taxCodeOptionsLoadingFailed stored in the state
const getTaxCodeOptionsLoadingFailed = createSelector(getTaxCodeMappingOptionState, ɵ4$4);

// Defines constant strings for the add/edit account form
class BmaaFormStrings {
    static getUserDefinedControl(scheduleId) {
        return `userDefined-${scheduleId}`;
    }
    static getUserDefinedDebitControl(scheduleId) {
        return `userDefinedDebit-${scheduleId}`;
    }
    static getUserDefinedCreditControl(scheduleId) {
        return `userDefinedCredit-${scheduleId}`;
    }
    static getUserDefinedTotalBalanceControl(scheduleId) {
        return `userDefinedTotalBalance-${scheduleId}`;
    }
}
BmaaFormStrings.ACCOUNT_NUMBER_MAX_LENGTH = 65;
BmaaFormStrings.ACCOUNT_NUMBER_PATTERN = '[a-zA-Z0-9-./\s ]*';
BmaaFormStrings.ACCOUNT_DESCRIPTION_MAX_LENGTH = 150;
BmaaFormStrings.ACCOUNT_NUMBER_CONTROL = 'accountNumberControl';
BmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL = 'accountDescriptionControl';
BmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL = 'accountClassificationComboboxControl';
BmaaFormStrings.ACCOUNT_CLASSFICATION_DEBIT_COMBOBOX_CONTROL = 'accountClassificationDebitComboboxControl';
BmaaFormStrings.ACCOUNT_CLASSFICATION_CREDIT_COMBOBOX_CONTROL = 'accountClassificationCreditComboboxControl';
BmaaFormStrings.ACCOUNT_CLASSFICATION_BALANCE_OPTION_COMBOBOX_CONTROL = 'accountClassificationBalanceOption';
BmaaFormStrings.TAX_CODE_COMBOBOX_CONTROL = 'taxCodeComboboxControl';
BmaaFormStrings.TAX_CODE_DEBIT_COMBOBOX_CONTROL = 'taxCodeDebitComboboxControl';
BmaaFormStrings.TAX_CODE_CREDIT_COMBOBOX_CONTROL = 'taxCodeCreditComboboxControl';
BmaaFormStrings.TAX_SCHEDULE_BALANCE_OPTION_COMBOBOX_CONTROL = 'taxScheduleBalanceOption';
BmaaFormStrings.NUMBER_DESCRIPTION_REQUIRED_ERROR = 'numberOrDescRequired';
BmaaFormStrings.DUPLICATE_ACCOUNT_NUMBER = 'duplicateAcctNumber';
BmaaFormStrings.PATTERN_ERROR = 'pattern';
BmaaFormStrings.REQUIRED_ERROR = 'required';
BmaaFormStrings.DUPLICATE_ACCOUNT_DESCRIPTION = 'duplicateAcctDesc';
BmaaFormStrings.ROUND_INDEPENDENTLY_CONTROL = 'roundIndependentlyControl';

// Returns with an error if both the account number and description controls are blank
const accountNumberOrDescriptionRequired = (control) => {
    const acctNumber = control.get(BmaaFormStrings.ACCOUNT_NUMBER_CONTROL);
    const acctDesc = control.get(BmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL);
    return acctNumber.touched && acctNumber.value === '' &&
        acctDesc.touched && acctDesc.value === '' ? { numberOrDescRequired: true } : null;
};

const ɵ0$7 = (state) => state.accountState;
// Returns the accountState
const getAccountState = createSelector(getAddAccountState, ɵ0$7);
const ɵ1$5 = (state) => state.accounts;
// Returns the accounts stored in the state
const getAccounts = createSelector(getAccountState, ɵ1$5);
const ɵ2$5 = (accounts) => accounts.filter((acct) => acct.accountNumber === undefined || acct.accountNumber === null || acct.accountNumber === '');
// Returns all of the accounts with no account number
const getAccountsWithoutNumber = createSelector(getAccounts, ɵ2$5);
const ɵ3$5 = (state) => state.accounts.map((account) => {
    return account.accountNumber;
});
// Returns a mapped array of just the account numbers
const getAccountNumbers = createSelector(getAccountState, ɵ3$5);
const ɵ4$5 = (accountsWithoutNumber) => {
    return accountsWithoutNumber.map((account) => {
        return account.description;
    });
};
// Returns a mapped array of just the account descriptions for accounts without an account number
const getAccountDescriptionsWithoutNumber = createSelector(getAccountsWithoutNumber, ɵ4$5);
const ɵ5$1 = (state) => state.accountsLoading;
// Returns the accountsLoading stored in the state
const getAccountsLoading = createSelector(getAccountState, ɵ5$1);
const ɵ6$1 = (state) => state.accountsLoaded;
// Returns the accountsLoaded stored in the state
const getAccountsLoaded = createSelector(getAccountState, ɵ6$1);
const ɵ7 = (state) => state.accountsLoadingFailed;
const getAccountsLoadingFailed = createSelector(getAccountState, ɵ7);
const ɵ8 = (accounts, editingAccount) => {
    return {
        accounts,
        editingAccountId: editingAccount === undefined ? undefined : editingAccount.id
    };
};
const getAccountsWithEditingAccountId = createSelector(getAccounts, getAccountToUpdate, ɵ8);
const ɵ9 = (accountsWithoutNumber, editingAccount) => {
    return {
        accountsWithoutNumber,
        editingAccountId: editingAccount === undefined ? undefined : editingAccount.id
    };
};
const getAccountsWithoutNumberWithEditingAccountId = createSelector(getAccountsWithoutNumber, getAccountToUpdate, ɵ9);

class BmaaDuplicateAccountNumberValidator {
    constructor(store) {
        this.store = store;
    }
    /**
     * Validates that the account number from acctNumCtrl is not a duplicate
     * @param acctNumCtrl Form control with the account number value
     */
    validate(acctNumCtrl) {
        return this.store.pipe(select(getAccountsWithEditingAccountId), map(accountsWithEditingAccount => {
            if (acctNumCtrl.value === undefined) {
                return null;
            }
            const numberFromForm = acctNumCtrl.value.trim().toLowerCase();
            const numberExists = accountsWithEditingAccount.accounts.find((acct) => {
                return acct.accountNumber !== undefined && acct.accountNumber.trim().toLowerCase() === numberFromForm &&
                    acct.id !== accountsWithEditingAccount.editingAccountId;
            });
            return acctNumCtrl.value !== '' && acctNumCtrl.value !== undefined && numberExists !== undefined ?
                { duplicateAcctNumber: true } : null;
        }), first());
    }
}
BmaaDuplicateAccountNumberValidator.ɵfac = function BmaaDuplicateAccountNumberValidator_Factory(t) { return new (t || BmaaDuplicateAccountNumberValidator)(ɵngcc0.ɵɵinject(ɵngcc1.Store)); };
BmaaDuplicateAccountNumberValidator.ɵprov = ɵɵdefineInjectable({ factory: function BmaaDuplicateAccountNumberValidator_Factory() { return new BmaaDuplicateAccountNumberValidator(ɵɵinject(Store)); }, token: BmaaDuplicateAccountNumberValidator, providedIn: "root" });
BmaaDuplicateAccountNumberValidator.ctorParameters = () => [
    { type: Store }
];

// The balance options for separating debit/credit groupings
// Choices: TotalBalance or DebitCredit
var BmaaBalanceOptions;
(function (BmaaBalanceOptions) {
    BmaaBalanceOptions["TotalBalance"] = "totalBalance";
    BmaaBalanceOptions["DebitCredit"] = "debitCredit";
})(BmaaBalanceOptions || (BmaaBalanceOptions = {}));

class BmaaDuplicateAccountDescriptionValidator {
    constructor(store) {
        this.store = store;
    }
    /**
     * Validates that the account number from acctNumCtrl is not a duplicate
     * @param formGroup Form group with an account number and account description control
     */
    validate(formGroup) {
        return this.store.pipe(select(getAccountsWithoutNumberWithEditingAccountId), map(accountsWithEditingAccount => {
            const acctNumber = formGroup.get(BmaaFormStrings.ACCOUNT_NUMBER_CONTROL);
            const acctDesc = formGroup.get(BmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL);
            if (acctDesc.value === undefined) {
                return null;
            }
            const trimmedLowerDesc = acctDesc.value.trim().toLowerCase();
            const desExists = accountsWithEditingAccount.accountsWithoutNumber.find((acct) => {
                return acct.description !== undefined && acct.description.trim().toLowerCase() === trimmedLowerDesc &&
                    acct.id !== accountsWithEditingAccount.editingAccountId;
            });
            return (acctNumber.value === undefined || acctNumber.value === '') && acctDesc.value !== '' && desExists !== undefined ?
                { duplicateAcctDesc: true } : null;
        }), first());
    }
}
BmaaDuplicateAccountDescriptionValidator.ɵfac = function BmaaDuplicateAccountDescriptionValidator_Factory(t) { return new (t || BmaaDuplicateAccountDescriptionValidator)(ɵngcc0.ɵɵinject(ɵngcc1.Store)); };
BmaaDuplicateAccountDescriptionValidator.ɵprov = ɵɵdefineInjectable({ factory: function BmaaDuplicateAccountDescriptionValidator_Factory() { return new BmaaDuplicateAccountDescriptionValidator(ɵɵinject(Store)); }, token: BmaaDuplicateAccountDescriptionValidator, providedIn: "root" });
BmaaDuplicateAccountDescriptionValidator.ctorParameters = () => [
    { type: Store }
];

// service to store and reutrn the current country code
class AccountLocaleService {
    // sets the current country code
    setCountryCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const environmentobject = yield this.getEnvironmentAsync();
            this.currentCountryCode = environmentobject.countryCode;
        });
    }
    // gets the enviornment data
    getEnvironmentAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield environment.getEnvironmentAsync();
        });
    }
    // returns current country code
    getCountryCode() {
        return this.currentCountryCode;
    }
    // returns true if current country is US
    isCurrentCountryUS() {
        return this.currentCountryCode === 'US';
    }
    // returns true is current country is Canada
    isCurrentCountryCA() {
        return this.currentCountryCode === 'CA';
    }
    // returns true is current country is UK
    isCurrentCountryUK() {
        return this.currentCountryCode === 'GB';
    }
    // returns true is current country is AR
    isCurrentCountryAR() {
        return this.currentCountryCode === 'AR';
    }
}
AccountLocaleService.ɵfac = function AccountLocaleService_Factory(t) { return new (t || AccountLocaleService)(); };
AccountLocaleService.ɵprov = ɵɵdefineInjectable({ factory: function AccountLocaleService_Factory() { return new AccountLocaleService(); }, token: AccountLocaleService, providedIn: "root" });

class AccountNumberFormComponent {
    constructor(localeService) {
        this.localeService = localeService;
    }
    /**
     * Getter of the form strings for use in the HTML
     */
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    /**
     * We want to manually run the validation on the form because it does not run on blur by default
     */
    runNumberDescriptionValidation() {
        this.addEditAccountForm.updateValueAndValidity();
    }
    // Focus on account number input on modal open and also disable account number for the AR/UK
    ngAfterViewInit() {
        // Using timeout to prevent ExpressionChangedAfterItHasBeenCheckedError in unit tests
        setTimeout(() => {
            // disable account number when current country is UK or AR and there is value of account number
            if ((this.localeService.isCurrentCountryUK() || this.localeService.isCurrentCountryAR()) &&
                this.accountNumberInput.nativeElement.value.length > 0) {
                this.accountNumberInput.nativeElement.disabled = true;
            }
            else {
                this.accountNumberInput.nativeElement.focus();
            }
        });
    }
    ngOnInit() {
    }
}
AccountNumberFormComponent.ɵfac = function AccountNumberFormComponent_Factory(t) { return new (t || AccountNumberFormComponent)(ɵngcc0.ɵɵdirectiveInject(AccountLocaleService)); };
AccountNumberFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccountNumberFormComponent, selectors: [["bmaa-account-number-form"]], viewQuery: function AccountNumberFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.accountNumberInput = _t.first);
    } }, inputs: { addEditAccountForm: "addEditAccountForm" }, decls: 8, vars: 10, consts: [["id", "bmaaAccountNumber", 1, "form-group", "bmaa-acct-number", 3, "formGroup", "ngClass"], ["for", "accountNumberControl"], ["maxlength", "65", "formControlName", "accountNumberControl", "autofocus", "", 1, "form-control", 3, "blur"], ["accountNumberInput", ""], ["class", "msg", 3, "translate", 4, "ngIf"], [1, "msg", 3, "translate"]], template: function AccountNumberFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2, 3);
        ɵngcc0.ɵɵlistener("blur", function AccountNumberFormComponent_Template_input_blur_4_listener() { return ctx.runNumberDescriptionValidation(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, AccountNumberFormComponent_div_6_Template, 2, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(7, AccountNumberFormComponent_div_7_Template, 2, 3, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.addEditAccountForm)("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c1, ctx.addEditAccountForm.get(ctx.bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(ctx.bmaaFormStrings.PATTERN_ERROR) || ctx.addEditAccountForm.get(ctx.bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(ctx.bmaaFormStrings.DUPLICATE_ACCOUNT_NUMBER)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 6, "bmaa_common_accountNumber"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.accountNumber");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addEditAccountForm.get(ctx.bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(ctx.bmaaFormStrings.PATTERN_ERROR));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addEditAccountForm.get(ctx.bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(ctx.bmaaFormStrings.DUPLICATE_ACCOUNT_NUMBER));
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.NgClass, ɵngcc2.DefaultValueAccessor, ɵngcc2.MaxLengthValidator, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc3.NgIf, ɵngcc4.TranslateDirective], pipes: [ɵngcc4.TranslatePipe], styles: [".bmaa-acct-number[_ngcontent-%COMP%]{margin-left:0;margin-right:0}"] });
AccountNumberFormComponent.ctorParameters = () => [
    { type: AccountLocaleService }
];
AccountNumberFormComponent.propDecorators = {
    addEditAccountForm: [{ type: Input }],
    accountNumberInput: [{ type: ViewChild, args: ['accountNumberInput', { static: true },] }]
};

class AccountPackagingService {
    constructor() { }
    /**
     * Packages a CategoryNodeAccount from a CategoryNodeOption and TotalBalanceCondition
     * @param categoryNodeOptionFromForm The CategoryNodeOption selected in the form
     * @param totalBalanceCondition The TotalBalanceCondition selected on the form
     * @param accountId The Account ID for the link. Optional because it's unnecessary for adding accounts
     * @param existingLinks The existing links for the schedule/account
     */
    createNewCategoryNodeAccount(categoryNodeOptionFromForm, totalBalanceCondition, accountId, existingLinks = []) {
        const existingMappingObject = existingLinks.find(categoryNode => categoryNode.accountId === accountId && categoryNode.categoryNodeId === categoryNodeOptionFromForm.id &&
            categoryNode.totalBalanceCondition === totalBalanceCondition);
        return existingMappingObject !== undefined ? existingMappingObject : {
            accountId,
            categoryNodeId: categoryNodeOptionFromForm.id,
            totalBalanceCondition
        };
    }
    /**
     * Packages a TaxCodeOption from a TaxCodeOption and TotalBalanceCondition
     * @param taxCodeOptionFromForm The TaxCodeOption selected on the form
     * @param totalBalanceCondition The TotalBalanceCondition selected on the form
     * @param accountId The Account ID for the link. Optional because it's unnecessary for adding account
     * @param existingTaxCodeAccountsLinks The existing links for the tax code account
     */
    createNewTaxCodeAccount(taxCodeOptionFromForm, totalBalanceCondition, accountId, existingTaxCodeAccountsLinks = []) {
        const existingMappingObject = existingTaxCodeAccountsLinks.find(taxCodeLink => taxCodeLink.accountId === accountId && taxCodeLink.taxCodeId === taxCodeOptionFromForm.id &&
            taxCodeLink.totalBalanceCondition === totalBalanceCondition);
        return existingMappingObject !== undefined ? existingMappingObject : {
            accountId,
            taxCodeId: taxCodeOptionFromForm.id,
            totalBalanceCondition,
        };
    }
    /**
     * Gets the CategoryNodeAccounts for the Account Classification Schedule using the values user selects in the combobox
     * @param addEditAccountForm The FormGroup with the selected values
     * @param allowDebitCreditGroupings Flag that determines whether or not we're allowed to use DebitCredit
     * @param accountId The Account ID for the link. Optional because it's unnecessary for adding account
     * @param existingAccountClassificationLinks The existing links for the schedule/account
     */
    packageCategoryNodeAccountsForAccountClassification(addEditAccountForm, allowDebitCreditGroupings, accountId, existingAccountClassificationLinks = []) {
        const categoryNodeAccounts = [];
        // User has selected debit/credit balances
        if (allowDebitCreditGroupings &&
            addEditAccountForm.value.accountClassificationBalanceOption === BmaaBalanceOptions.DebitCredit) {
            if (addEditAccountForm.value.accountClassificationDebitComboboxControl !== null) {
                categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value.accountClassificationDebitComboboxControl, TotalBalanceCondition.DebitBalances, accountId, existingAccountClassificationLinks));
            }
            if (addEditAccountForm.value.accountClassificationCreditComboboxControl !== null) {
                categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value.accountClassificationCreditComboboxControl, TotalBalanceCondition.CreditBalances, accountId, existingAccountClassificationLinks));
            }
            // User has selected total balance or allowDebitCreditGroupings is false
        }
        else if (addEditAccountForm.value.accountClassificationComboboxControl !== null) {
            categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value.accountClassificationComboboxControl, TotalBalanceCondition.AllBalances, accountId, existingAccountClassificationLinks));
        }
        // if no value selected in combobox of account classifications combobox
        if (addEditAccountForm.value.accountClassificationDebitComboboxControl === null &&
            addEditAccountForm.value.accountClassificationCreditComboboxControl === null &&
            addEditAccountForm.value.accountClassificationComboboxControl === null &&
            existingAccountClassificationLinks !== undefined) {
            // mark existing account classification link as deleted
            this.deleteUnassignedAccountLinks(existingAccountClassificationLinks, categoryNodeAccounts);
        }
        return categoryNodeAccounts;
    }
    /**
     * Gets the TaxCodeAccounts for the Tax Schedule using the values user selects in the combobox
     * @param addEditAccountForm The FormGroup with the selected values
     * @param allowDebitCreditGroupings Flag that determines whether or not we're allowed to use DebitCredit
     * @param accountId The Account ID for the link. Optional because it's unnecessary for adding account
     * @param existingTaxCodeAccountsLinks The existing links for the tax code account
     */
    packageTaxCodeAccountsForTaxSchedule(addEditAccountForm, allowDebitCreditGroupings, accountId, existingTaxCodeAccountsLinks = []) {
        const taxCodeAccounts = [];
        // User has selected debit/credit balances
        if (allowDebitCreditGroupings && addEditAccountForm.value.taxScheduleBalanceOption === BmaaBalanceOptions.DebitCredit) {
            if (addEditAccountForm.value.taxCodeDebitComboboxControl !== null) {
                taxCodeAccounts.push(this.createNewTaxCodeAccount(addEditAccountForm.value.taxCodeDebitComboboxControl, TotalBalanceCondition.DebitBalances, accountId, existingTaxCodeAccountsLinks));
            }
            if (addEditAccountForm.value.taxCodeCreditComboboxControl !== null) {
                taxCodeAccounts.push(this.createNewTaxCodeAccount(addEditAccountForm.value.taxCodeCreditComboboxControl, TotalBalanceCondition.CreditBalances, accountId, existingTaxCodeAccountsLinks));
            }
            // User has selected total balance or allowDebitCreditGroupings is flase
        }
        else if (addEditAccountForm.value.taxCodeComboboxControl !== null) {
            taxCodeAccounts.push(this.createNewTaxCodeAccount(addEditAccountForm.value.taxCodeComboboxControl, TotalBalanceCondition.AllBalances, accountId, existingTaxCodeAccountsLinks));
        }
        // if no value selected in combobox for tax code account
        if (addEditAccountForm.value.taxCodeDebitComboboxControl === null &&
            addEditAccountForm.value.taxCodeCreditComboboxControl === null &&
            addEditAccountForm.value.taxCodeComboboxControl === null &&
            existingTaxCodeAccountsLinks !== undefined) {
            // mark existing tax code account link as deleted
            this.deleteUnassignedAccountLinks(existingTaxCodeAccountsLinks, taxCodeAccounts);
        }
        return taxCodeAccounts;
    }
    /**
     * Gets the CategoryNodeAccounts for a User Defined Schedule using the values user selects in the combobox
     * @param addEditAccountForm The FormGroup with the selected values
     * @param allowDebitCreditGroupings Flag that determines whether or not we're allowed to use DebitCredit
     * @param scheduleId The id of the user defined schedule
     * @param accountId The Account ID for the link. Optional because it's unnecessary for adding account
     * @param existingUserDefinedLinks existing links for the schedule/account
     */
    packageCategoryNodeAccountsForUserDefinedSchedule(addEditAccountForm, allowDebitCreditGroupings, scheduleId, accountId, existingUserDefinedLinks = []) {
        const categoryNodeAccounts = [];
        // User has selected debit/credit balances for this schedule
        if (allowDebitCreditGroupings &&
            addEditAccountForm.value[BmaaFormStrings.getUserDefinedTotalBalanceControl(scheduleId)] === BmaaBalanceOptions.DebitCredit) {
            if (addEditAccountForm.value[BmaaFormStrings.getUserDefinedDebitControl(scheduleId)] !== null) {
                categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value[BmaaFormStrings.getUserDefinedDebitControl(scheduleId)], TotalBalanceCondition.DebitBalances, accountId, existingUserDefinedLinks));
            }
            if (addEditAccountForm.value[BmaaFormStrings.getUserDefinedCreditControl(scheduleId)] !== null) {
                categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value[BmaaFormStrings.getUserDefinedCreditControl(scheduleId)], TotalBalanceCondition.CreditBalances, accountId, existingUserDefinedLinks));
            }
            // User has selected total balance or allowDebitCreditGroupings is false
        }
        else if (addEditAccountForm.value[BmaaFormStrings.getUserDefinedControl(scheduleId)] !== null) {
            categoryNodeAccounts.push(this.createNewCategoryNodeAccount(addEditAccountForm.value[BmaaFormStrings.getUserDefinedControl(scheduleId)], TotalBalanceCondition.AllBalances, accountId, existingUserDefinedLinks));
        }
        // if no value selected in combobox of user defined schedules
        if (addEditAccountForm.value[BmaaFormStrings.getUserDefinedDebitControl(scheduleId)] === null &&
            addEditAccountForm.value[BmaaFormStrings.getUserDefinedCreditControl(scheduleId)] === null &&
            addEditAccountForm.value[BmaaFormStrings.getUserDefinedControl(scheduleId)] === null &&
            existingUserDefinedLinks !== undefined) {
            // mark existing user defined schedules link as deleted
            this.deleteUnassignedAccountLinks(existingUserDefinedLinks, categoryNodeAccounts);
        }
        return categoryNodeAccounts;
    }
    /**
     * Set the isDelete flag for the account links if there is no mapping against it
     * @param accountLinksAssigned The existing account links for the schedule / account
     * @param accountLinks accountLinks for the CategoryNodeAccounts / schedules / taxCodeAccounts
     */
    deleteUnassignedAccountLinks(accountLinksAssigned, accountLinks) {
        let accountLinkAssignedObject = [];
        // map and copy in different object
        accountLinkAssignedObject = accountLinksAssigned.map(accountLink => {
            return Object.assign({}, accountLink);
        });
        // set the deleted flag as currently there is no mapping against it
        accountLinkAssignedObject.forEach(element => {
            element.isDeleted = true;
        });
        accountLinks.push(...accountLinkAssignedObject);
        return accountLinks;
    }
}
AccountPackagingService.ɵfac = function AccountPackagingService_Factory(t) { return new (t || AccountPackagingService)(); };
AccountPackagingService.ɵprov = ɵɵdefineInjectable({ factory: function AccountPackagingService_Factory() { return new AccountPackagingService(); }, token: AccountPackagingService, providedIn: "root" });
AccountPackagingService.ctorParameters = () => [];

// The account frp for RoundIndependentlyAccounts
var AccountFrp;
(function (AccountFrp) {
    AccountFrp["RoundIndependentlyAccounts"] = "Accounts.RoundIndependentlyAccounts";
})(AccountFrp || (AccountFrp = {}));

// service to store and reutrn the current country code
class AccountFrpService {
    /**
     * Return the StatutoryReporting FRP
     */
    hasStatutoryReportingFrp() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield has(['Accounts.StatutoryReporting']);
        });
    }
    /**
     * Return the RoundIndependentlyAccounts FRP
     */
    hasRoundIndependentlyAccountsFrp() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield has([AccountFrp.RoundIndependentlyAccounts]);
        });
    }
}
AccountFrpService.ɵfac = function AccountFrpService_Factory(t) { return new (t || AccountFrpService)(); };
AccountFrpService.ɵprov = ɵɵdefineInjectable({ factory: function AccountFrpService_Factory() { return new AccountFrpService(); }, token: AccountFrpService, providedIn: "root" });

class AddAccountModalComponent {
    constructor(fb, store, duplicateAccountNumberValidator, activeModal, duplicateAccountDescriptionValidator, accountPackagingService, frpService) {
        this.fb = fb;
        this.store = store;
        this.duplicateAccountNumberValidator = duplicateAccountNumberValidator;
        this.activeModal = activeModal;
        this.duplicateAccountDescriptionValidator = duplicateAccountDescriptionValidator;
        this.accountPackagingService = accountPackagingService;
        this.frpService = frpService;
        this.defaultFirstGrouping = false;
        this.allowDebitCreditGroupings = false;
        this.hasStatutoryReportingFrp = false;
        this.categoryNodeOptionComboboxObservable = new Map();
        this.isEquityAccountModal = false;
        this.hasAnyGroupings = false;
        // Emits an event when an account is saved with account to save
        this.saveAccount = new EventEmitter();
        // Defines the controls and validators for the addAccountForm
        this.addAccountForm = this.fb.group({
            accountNumberControl: ['', {
                    validators: [Validators.pattern(this.bmaaFormStrings.ACCOUNT_NUMBER_PATTERN),
                        Validators.maxLength(this.bmaaFormStrings.ACCOUNT_NUMBER_MAX_LENGTH)],
                    asyncValidators: this.duplicateAccountNumberValidator.validate.bind(this.duplicateAccountNumberValidator),
                }],
            accountDescriptionControl: ['', {
                    valdiators: [Validators.maxLength(this.bmaaFormStrings.ACCOUNT_DESCRIPTION_MAX_LENGTH)],
                }],
            accountClassificationComboboxControl: [null],
            accountClassificationDebitComboboxControl: [null],
            accountClassificationCreditComboboxControl: [null],
            accountClassificationBalanceOption: [BmaaBalanceOptions.TotalBalance],
            taxScheduleBalanceOption: [BmaaBalanceOptions.TotalBalance],
            taxCodeComboboxControl: [null],
            taxCodeDebitComboboxControl: [null],
            taxCodeCreditComboboxControl: [null],
            roundIndependentlyControl: [null],
        }, {
            validators: [accountNumberOrDescriptionRequired],
            asyncValidators: this.duplicateAccountDescriptionValidator.validate.bind(this.duplicateAccountDescriptionValidator),
        });
    }
    // Getter of the balance options for use in the HTML
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    /**
     * Returns an observable of the categoryNodeOptions for the accountGroupId for use by BentoCombobox
     * Returns the observable if exists or creates it if it doesn't
     * @param accountGroupId The schedule for which to an get/create observable
     */
    getCategoryNodeOptionsForSchedule(accountGroupId) {
        if (this.categoryNodeOptionComboboxObservable[accountGroupId] === undefined) {
            this.categoryNodeOptionComboboxObservable[accountGroupId] =
                this.store.pipe(select(getCategoryNodeMappingOptions, { accountGroupId }));
        }
        return this.categoryNodeOptionComboboxObservable[accountGroupId];
    }
    /**
     * Sets the account classification combobox to the first option in the dropdown
     */
    setFirstGrouping() {
        this.store.pipe(select(getCategoryNodeMappingOptions, {
            accountGroupId: this.accountClassificationSchedule.id
        })).subscribe((options) => {
            this.addAccountForm.controls.accountClassificationComboboxControl.setValue(options[0]);
        });
    }
    /**
     * Resets add account form to default values
     */
    resetForm() {
        this.addAccountForm.reset({
            accountNumberControl: '',
            accountDescriptionControl: '',
            accountClassificationComboboxControl: null,
            accountClassificationDebitComboboxControl: null,
            accountClassificationCreditComboboxControl: null,
            accountClassificationBalanceOption: BmaaBalanceOptions.TotalBalance,
            taxScheduleBalanceOption: BmaaBalanceOptions.TotalBalance,
            taxCodeComboboxControl: null,
            taxCodeDebitComboboxControl: null,
            taxCodeCreditComboboxControl: null,
            roundIndependentlyControl: null,
        });
        this.userDefinedSchedules.forEach((schedule) => {
            this.addAccountForm.controls[this.bmaaFormStrings.getUserDefinedControl(schedule.id)].setValue(null);
            this.addAccountForm.controls[this.bmaaFormStrings.getUserDefinedDebitControl(schedule.id)].setValue(null);
            this.addAccountForm.controls[this.bmaaFormStrings.getUserDefinedCreditControl(schedule.id)].setValue(null);
            this.addAccountForm.controls[this.bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule.id)]
                .setValue(BmaaBalanceOptions.TotalBalance);
        });
        // We might need to reset the account classification combobox to the first option
        if (this.defaultFirstGrouping) {
            this.setFirstGrouping();
        }
    }
    /**
     * Creates the account to save, emits the saveAccountEvent and resets the form/closes the modal based on closeModal
     * @param closeModal Tells the function whether to close the modal or reset the form
     */
    saveNewAccount(closeModal) {
        // If the form is not valid, don't let the save through
        if (this.addAccountForm.valid) {
            this.store.pipe(select(getOwnerId), first(ownerId => ownerId !== undefined))
                .toPromise()
                .then(ownerId => {
                // Account classfication Schedule
                let categoryNodeAccounts = this.accountPackagingService
                    .packageCategoryNodeAccountsForAccountClassification(this.addAccountForm, this.allowDebitCreditGroupings);
                // Tax Schedule
                const taxCodeAccounts = this.accountPackagingService
                    .packageTaxCodeAccountsForTaxSchedule(this.addAccountForm, this.allowDebitCreditGroupings);
                // User defined schedules
                this.userDefinedSchedules.forEach((schedule) => {
                    categoryNodeAccounts = categoryNodeAccounts.concat(this.accountPackagingService
                        .packageCategoryNodeAccountsForUserDefinedSchedule(this.addAccountForm, this.allowDebitCreditGroupings, schedule.id));
                });
                // Package the account to save
                const newAccount = {
                    ownerId,
                };
                // If there's no account number, we want to not add the value to the saved account
                if (this.addAccountForm.value.accountNumberControl !== '') {
                    newAccount.accountNumber = this.addAccountForm.value.accountNumberControl;
                }
                // If there's no account description, we want to not add the value to the sent in account
                if (this.addAccountForm.value.accountDescriptionControl !== '') {
                    newAccount.description = this.addAccountForm.value.accountDescriptionControl;
                }
                const newAccountWithLinks = {
                    account: newAccount,
                    categoryNodeAccounts,
                    taxCodeAccounts
                };
                // Get the rounding toogle Status
                const roundIndependently = this.addAccountForm.value.roundIndependentlyControl;
                const saveAccountObj = {
                    newAccountWithLinks,
                    roundIndependently
                };
                this.saveAccount.emit(saveAccountObj);
                if (closeModal) {
                    this.activeModal.close();
                }
                else {
                    this.resetForm();
                    this.accountNumberComponent.accountNumberInput.nativeElement.focus();
                }
            });
        }
    }
    /**
     * Saves an account and resets the form
     */
    saveAddNew() {
        this.saveNewAccount(false);
    }
    /**
     * Saves an account and closes the modal
     */
    saveAndClose() {
        this.saveNewAccount(true);
    }
    /**
     * Dismiss the modal
     */
    cancel() {
        this.activeModal.dismiss();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the StatutoryReporting Frp
            this.hasStatutoryReportingFrp = yield this.frpService.hasStatutoryReportingFrp();
            // Loads the defaultFirstGrouping from the state
            this.store
                .pipe(select(getDefaultFirstGrouping), first(defGrouping => defGrouping !== undefined))
                .toPromise()
                .then(defGrouping => {
                this.addAccountForm.controls.accountClassificationComboboxControl.setValidators(Validators.required);
                this.defaultFirstGrouping = defGrouping;
            });
            // Loads the allowDebitCredit from the state
            this.store
                .pipe(select(getAllowDebitCredit), first(allowDebCred => allowDebCred !== undefined))
                .toPromise()
                .then(allowDebCred => {
                this.allowDebitCreditGroupings = allowDebCred;
            });
            // Loads the isEquityAccountModal from the state
            this.store
                .pipe(select(getIsEquityAccountModal), first(isEquityAccountModal => isEquityAccountModal !== undefined))
                .toPromise()
                .then(isEquityAccountModal => {
                this.isEquityAccountModal = Boolean(isEquityAccountModal);
            });
            // Loads the account groups from the state
            this.store
                .pipe(select(getAccountGroupState), first(accountGroupsState => accountGroupsState.accountGroupsLoaded))
                .toPromise()
                .then(accountGroupsState => {
                // Separate out the account classification schedule
                const accountGroups = accountGroupsState.accountGroups;
                this.accountClassificationSchedule = accountGroups.find(group => {
                    return group.isStandardAccountClassification;
                });
                // If we want to default to the first grouping, get the mapping options and set the combobox control to the first one
                if (this.defaultFirstGrouping) {
                    this.setFirstGrouping();
                }
                this.userDefinedSchedules = accountGroups.filter(group => {
                    return !group.isStandardAccountClassification;
                });
                if (accountGroups.length > 0) {
                    this.hasAnyGroupings = true;
                }
                // Add form controls for each user defined schedule
                this.userDefinedSchedules.forEach(schedule => {
                    this.addAccountForm.addControl(this.bmaaFormStrings.getUserDefinedControl(schedule.id), new FormControl(null));
                    this.addAccountForm.addControl(this.bmaaFormStrings.getUserDefinedDebitControl(schedule.id), new FormControl(null));
                    this.addAccountForm.addControl(this.bmaaFormStrings.getUserDefinedCreditControl(schedule.id), new FormControl(null));
                    this.addAccountForm.addControl(this.bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule.id), new FormControl(BmaaBalanceOptions.TotalBalance));
                });
            });
            // Load the tax schedule from the store
            this.store
                .pipe(select(getTaxSchedule), first(taxSchedule => taxSchedule !== undefined && taxSchedule !== null))
                .toPromise()
                .then(taxSchedule => {
                this.taxSchedule = taxSchedule;
                this.hasAnyGroupings = true;
            });
            // Load the mapping options from the state and when they're loaded, set the observable for the combobox
            this.store
                .pipe(select(getTaxCodeMappingOptionState), first(taxCodeOptionState => taxCodeOptionState.taxCodeOptionsLoaded))
                .toPromise()
                .then(() => {
                this.taxCodeOptionComboboxObservable = this.store.pipe(select(getTaxCodeOptions));
            });
        });
    }
}
AddAccountModalComponent.ɵfac = function AddAccountModalComponent_Factory(t) { return new (t || AddAccountModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store), ɵngcc0.ɵɵdirectiveInject(BmaaDuplicateAccountNumberValidator), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(BmaaDuplicateAccountDescriptionValidator), ɵngcc0.ɵɵdirectiveInject(AccountPackagingService), ɵngcc0.ɵɵdirectiveInject(AccountFrpService)); };
AddAccountModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AddAccountModalComponent, selectors: [["bmaa-add-account-modal"]], viewQuery: function AddAccountModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.accountNumberComponent = _t.first);
    } }, outputs: { saveAccount: "saveAccount" }, decls: 34, vars: 26, consts: [[1, "bmaa-modal"], ["novalidate", "", 3, "formGroup"], ["type", "button", "aria-hidden", "true", 1, "close", 3, "click"], [1, "bento-icon-close-x"], ["class", "modal-header bmaa-header-title", 4, "ngIf", "ngIfElse"], ["addAccountLabel", ""], [1, "modal-body"], ["modalBody", ""], [1, "form-horizontal"], ["class", "form-group", 4, "ngIf"], [3, "addEditAccountForm"], ["accountNumberComponent", ""], [3, "addEditAccountForm", 4, "ngIf"], [1, "form-group"], [1, "col-md-12"], [3, "schedule", "modalBodyReference", "optionsObservable", "addEditAccountForm", "balanceOptionFormControlName", "totalBalanceComboboxControlName", "debitComboboxControlName", "creditComboboxControlName", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-default", 3, "click"], [1, "modal-header", "bmaa-header-title"], ["role", "alert", 1, "alert", "bento-alert", "alert-danger"], [1, "bmaa-alert-text", 3, "translate"], [2, "font-size", "16px", 3, "translate"], [3, "schedule", "modalBodyReference", "optionsObservable", "addEditAccountForm", "balanceOptionFormControlName", "totalBalanceComboboxControlName", "debitComboboxControlName", "creditComboboxControlName"]], template: function AddAccountModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "form", 1)(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function AddAccountModalComponent_Template_button_click_2_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, AddAccountModalComponent_div_4_Template, 3, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(5, AddAccountModalComponent_ng_template_5_Template, 3, 3, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(7, "div", 6, 7)(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, AddAccountModalComponent_div_10_Template, 4, 3, "div", 9);
        ɵngcc0.ɵɵelement(11, "bmaa-account-number-form", 10, 11)(13, "bmaa-account-description-form", 10);
        ɵngcc0.ɵɵtemplate(14, AddAccountModalComponent_bmaa_round_independently_form_14_Template, 1, 1, "bmaa-round-independently-form", 12);
        ɵngcc0.ɵɵelementStart(15, "div", 13);
        ɵngcc0.ɵɵelement(16, "div", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, AddAccountModalComponent_div_17_Template, 3, 3, "div", 9);
        ɵngcc0.ɵɵtemplate(18, AddAccountModalComponent_bmaa_account_grouping_form_18_Template, 1, 8, "bmaa-account-grouping-form", 15);
        ɵngcc0.ɵɵtemplate(19, AddAccountModalComponent_bmaa_account_grouping_form_19_Template, 1, 8, "bmaa-account-grouping-form", 15);
        ɵngcc0.ɵɵtemplate(20, AddAccountModalComponent_div_20_Template, 2, 8, "div", 16);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(21, "div", 17)(22, "button", 18);
        ɵngcc0.ɵɵlistener("click", function AddAccountModalComponent_Template_button_click_22_listener() { return ctx.saveAndClose(); });
        ɵngcc0.ɵɵelementStart(23, "span");
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵpipe(25, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(26, "button", 18);
        ɵngcc0.ɵɵlistener("click", function AddAccountModalComponent_Template_button_click_26_listener() { return ctx.saveAddNew(); });
        ɵngcc0.ɵɵelementStart(27, "span");
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵpipe(29, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(30, "button", 19);
        ɵngcc0.ɵɵlistener("click", function AddAccountModalComponent_Template_button_click_30_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementStart(31, "span");
        ɵngcc0.ɵɵtext(32);
        ɵngcc0.ɵɵpipe(33, "translate");
        ɵngcc0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.addAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.cancel.top");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEquityAccountModal)("ngIfElse", _r1);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addAccountForm.hasError(ctx.bmaaFormStrings.NUMBER_DESCRIPTION_REQUIRED_ERROR));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("addEditAccountForm", ctx.addAccountForm);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("addEditAccountForm", ctx.addAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasStatutoryReportingFrp);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAnyGroupings);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accountClassificationSchedule !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.taxSchedule !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.userDefinedSchedules);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.addAccountForm.valid || ctx.addAccountForm.value.accountNumberControl === "" && ctx.addAccountForm.value.accountDescriptionControl === "");
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.save");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(25, 20, "bmaa_addEditAccount_saveClose"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.addAccountForm.valid || ctx.addAccountForm.value.accountNumberControl === "" && ctx.addAccountForm.value.accountDescriptionControl === "");
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.saveAddNew");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(29, 22, "bmaa_addEditAccount_saveAddNew"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.cancel");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(33, 24, "bmaa_common_cancel"));
    } }, directives: function () { return [ɵngcc2.ɵNgNoValidate, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc6.BentoFocusMonitorDirective, ɵngcc3.NgIf, ɵngcc4.TranslateDirective, AccountNumberFormComponent, AccountDescriptionFormComponent, RoundIndependentlyFormComponent, AccountGroupingFormComponent, ɵngcc3.NgForOf, ɵngcc6.BentoFooterTabHelper]; }, pipes: function () { return [ɵngcc4.TranslatePipe]; }, styles: [".bmaa-modal[_ngcontent-%COMP%]   .form-group[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.bmaa-modal[_ngcontent-%COMP%]   .bmaa-alert-text[_ngcontent-%COMP%]{margin-left:25px}.bmaa-modal[_ngcontent-%COMP%]   .bmaa-header-title[_ngcontent-%COMP%]{justify-content:left}"] });
AddAccountModalComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Store },
    { type: BmaaDuplicateAccountNumberValidator },
    { type: NgbActiveModal },
    { type: BmaaDuplicateAccountDescriptionValidator },
    { type: AccountPackagingService },
    { type: AccountFrpService }
];
AddAccountModalComponent.propDecorators = {
    accountNumberComponent: [{ type: ViewChild, args: ['accountNumberComponent', { static: true },] }],
    saveAccount: [{ type: Output }]
};

// The account tag type for RoundIndependently and RoundIndependentlyInitial
var BmaaAccountTags;
(function (BmaaAccountTags) {
    BmaaAccountTags["RoundIndependently"] = "OSR_RoundIndependently";
    BmaaAccountTags["RoundIndependentlyInitial"] = "OSR_RoundIndependentlyInitial";
})(BmaaAccountTags || (BmaaAccountTags = {}));

const ɵ0$8 = (state) => state.accountTagState;
// Returns the accountTagState
const getAccountTagState = createSelector(getAddAccountState, ɵ0$8);
const ɵ1$6 = (state) => state.accountTags;
// Returns the accounTags stored in the state
const getAccountTags = createSelector(getAccountTagState, ɵ1$6);
const ɵ2$6 = (state, props) => {
    if (state.accountTagsLoaded && props !== undefined) {
        return state.accountTags.find(accountTag => accountTag.accountId === props.accountId && accountTag.tag === props.tag);
    }
};
// Returns the accountTag for account and tag
const getAccountTagForAccountAndTag = createSelector(getAccountTagState, ɵ2$6);
const ɵ3$6 = (acct, state) => {
    if (acct !== undefined && state.accountTagsLoaded) {
        return state.accountTags.find(accountTag => accountTag.accountId === acct.id && accountTag.tag === BmaaAccountTags.RoundIndependentlyInitial);
    }
};
// Returns roundIndependentlyInitial tag for edit account
const getRoundIndependentlyInitialTagForEditAccount = createSelector(getAccountToUpdate, getAccountTagState, ɵ3$6);
const ɵ4$6 = (acct, accountTags) => {
    if (acct !== undefined && accountTags) {
        return accountTags.find(accountTag => accountTag.accountId === acct.id && accountTag.tag === BmaaAccountTags.RoundIndependently);
    }
};
// Returns roundIndependently tag for edit account
const getRoundIndependentlyTagForEditAccount = createSelector(getAccountToUpdate, getAccountTags, ɵ4$6);
const ɵ5$2 = (state) => state.accountTagsLoading;
// Returns the accountTagsLoading stored in the state
const getAccountTagsLoading = createSelector(getAccountTagState, ɵ5$2);
const ɵ6$2 = (state) => state.accountTagsLoaded;
// Returns the accountTagsLoaded stored in the state
const getAccountTagsLoaded = createSelector(getAccountTagState, ɵ6$2);
const ɵ7$1 = (state) => state.accountTagsLoadingFailed;
// Gets the accountTagsLoadingFailed stored in the state
const getAccountTagsLoadingFailed = createSelector(getAccountTagState, ɵ7$1);

const ɵ0$9 = (state) => state.accountWithTaxScheduleLinkState;
// Gets the accountWithTaxScheduleLinkState
const getAccountWithTaxScheduleLinkState = createSelector(getAddAccountState, ɵ0$9);
const ɵ1$7 = (state) => state.accountWithTaxScheduleLinks;
// Gets the accountWithTaxScheduleLinks stored in the state
const getAccountsWithTaxScheduleLinks = createSelector(getAccountWithTaxScheduleLinkState, ɵ1$7);
const ɵ2$7 = (state) => state.accountWithTaxScheduleLinksLoading;
// Gets the accountWithTaxScheduleLinksLoading stored in the state
const getAccountsWithTaxScheduleLinksLoading = createSelector(getAccountWithTaxScheduleLinkState, ɵ2$7);
const ɵ3$7 = (state) => state.accountWithTaxScheduleLinksLoaded;
// Gets the accountWithTaxScheduleLinksLoaded stored in the state
const getAccountsWithTaxScheduleLinksLoaded = createSelector(getAccountWithTaxScheduleLinkState, ɵ3$7);
const ɵ4$7 = (state) => state.accountWithTaxScheduleLinksLoadingFailed;
// Gets the accountWithTaxScheduleLinksLoadingFailed stored in the state
const getAccountsWithTaxScheduleLinksLoadingFailed = createSelector(getAccountWithTaxScheduleLinkState, ɵ4$7);
const ɵ5$3 = (taxScheduleLinks, props) => taxScheduleLinks !== undefined ? taxScheduleLinks.find(link => link.account.id === props.accountId) : undefined;
const getTaxScheduleLinksForAccount = createSelector(getAccountsWithTaxScheduleLinks, ɵ5$3);

const ɵ0$a = (state) => state.accountWithAccountGroupLinkState;
// Gets the entire accountWithAccountGroupLinkState
const getAccountWithAccountGroupLinksState = createSelector(getAddAccountState, ɵ0$a);
const ɵ1$8 = (state, selectorProps) => state.entities[selectorProps.accountGroupId] !== undefined ?
    state.entities[selectorProps.accountGroupId].accountWithAccountGroupLinks : undefined;
// Gets the accountWithAccountGroupLinks from the state for accountGroupId
const getAccountsWithAccountGroupLinks = createSelector(getAccountWithAccountGroupLinksState, ɵ1$8);
const ɵ2$8 = (state, selectorProps) => state.entities[selectorProps.accountGroupId].accountWithAccountGroupLinksLoading;
// Gets accountWithAccountGroupLinksLoading for accountGroupId
const getAccountsWithAccountGroupLoading = createSelector(getAccountWithAccountGroupLinksState, ɵ2$8);
const ɵ3$8 = (state, selectorProps) => state.entities[selectorProps.accountGroupId].accountWithAccountGroupLinksLoaded;
// Gets accountWithAccountGroupLinksLoaded for accountGroupId
const getAccountsWithAccountGroupLoaded = createSelector(getAccountWithAccountGroupLinksState, ɵ3$8);
const ɵ4$8 = (state, selectorProps) => state.entities[selectorProps.accountGroupId].accountWithAccountGroupLinksLoadingFailed;
// Gets accountWithAccountGroupLinksLoadingFailed for accountGroupId
const getAccountsWithAccountGroupLoadingFailed = createSelector(getAccountWithAccountGroupLinksState, ɵ4$8);
const ɵ5$4 = (accountGroupLinks, selectorProps) => accountGroupLinks !== undefined ? accountGroupLinks.find(link => link.account.id === selectorProps.accountId) : undefined;
const getAccountGroupLinksForAccount = createSelector(getAccountsWithAccountGroupLinks, ɵ5$4);
const ɵ6$3 = (state, selectorProps) => {
    const accountGroupLinksWithGroupId = [];
    selectorProps.accountGroupIds.forEach(accountGroupId => {
        var _a;
        const accountWithAccountGroupLinks = (_a = state.entities[accountGroupId]) === null || _a === void 0 ? void 0 : _a.accountWithAccountGroupLinks;
        const accountGroupLinks = accountWithAccountGroupLinks !== undefined ?
            accountWithAccountGroupLinks.find(link => link.account.id === selectorProps.accountId) : undefined;
        accountGroupLinksWithGroupId.push({ accountGroupId, accountGroupLinks });
    });
    return accountGroupLinksWithGroupId;
};
// Gets the accountWithAccountGroupLinks for accountGroupIds
const getAccountGroupLinksByGroupIds = createSelector(getAccountWithAccountGroupLinksState, ɵ6$3);

class EditAccountModalComponent {
    constructor(activeModal, fb, duplicateAccountNumberValidator, duplicateAccountDescriptionValidator, store, accountPackagingService, frpService) {
        this.activeModal = activeModal;
        this.fb = fb;
        this.duplicateAccountNumberValidator = duplicateAccountNumberValidator;
        this.duplicateAccountDescriptionValidator = duplicateAccountDescriptionValidator;
        this.store = store;
        this.accountPackagingService = accountPackagingService;
        this.frpService = frpService;
        this.allowDebitCreditGroupings = false;
        this.categoryNodeOptionComboboxObservable = new Map();
        this.hasStatutoryReportingFrp = false;
        this.hasAnyGroupings = false;
        this.editAccountForm = this.fb.group({
            accountNumberControl: ['', {
                    validators: [Validators.pattern(this.bmaaFormStrings.ACCOUNT_NUMBER_PATTERN),
                        Validators.maxLength(this.bmaaFormStrings.ACCOUNT_NUMBER_MAX_LENGTH)],
                    asyncValidators: this.duplicateAccountNumberValidator.validate.bind(this.duplicateAccountNumberValidator),
                }],
            accountDescriptionControl: ['', {
                    valdiators: [Validators.maxLength(this.bmaaFormStrings.ACCOUNT_DESCRIPTION_MAX_LENGTH)],
                }],
            accountClassificationComboboxControl: [null],
            accountClassificationDebitComboboxControl: [null],
            accountClassificationCreditComboboxControl: [null],
            accountClassificationBalanceOption: [BmaaBalanceOptions.TotalBalance],
            taxScheduleBalanceOption: [BmaaBalanceOptions.TotalBalance],
            taxCodeComboboxControl: [null],
            taxCodeDebitComboboxControl: [null],
            taxCodeCreditComboboxControl: [null],
            roundIndependentlyControl: false,
        }, {
            validators: [accountNumberOrDescriptionRequired],
            asyncValidators: this.duplicateAccountDescriptionValidator.validate.bind(this.duplicateAccountDescriptionValidator),
        });
    }
    /**
     * Getter of the balance options for use in the HTML
     */
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    /**
     * Returns an observable of the categoryNodeOptions for the accountGroupId for use by BentoCombobox
     * Sets the observable in categoryNodeOptionComboboxObservable if it doesn't exist and returns it if it does
     * @param accountGroupId The ID of the account group to get/create the observable for
     */
    getCategoryNodeOptionsForSchedule(accountGroupId) {
        if (this.categoryNodeOptionComboboxObservable[accountGroupId] === undefined) {
            this.categoryNodeOptionComboboxObservable[accountGroupId] =
                this.store.pipe(select(getCategoryNodeMappingOptions, { accountGroupId }));
            // For Meera: Potential Alternative is to put this code in the grouping component and only run it if in edit mode.
            // Which do you like more?
            this.store.pipe(select(getAccountGroupLinksForAccount, {
                accountId: this.initialAccountInformation.id,
                accountGroupId,
            })).subscribe(links => {
                var _a;
                if (links !== undefined) {
                    if (accountGroupId === ((_a = this.accountClassificationSchedule) === null || _a === void 0 ? void 0 : _a.id)) {
                        this.setExistingAccountClassificationMappings(links.categoryNodeAccountsAssigned, accountGroupId);
                    }
                    else {
                        this.setExistingUserDefinedScheduleMappings(links.categoryNodeAccountsAssigned, accountGroupId);
                    }
                }
            });
        }
        return this.categoryNodeOptionComboboxObservable[accountGroupId];
    }
    /**
     * Creates the account object and sends it to the AddAccountComponent to be saved
     */
    saveUpdatedAccount() {
        if (this.editAccountForm.valid) {
            // Get all schedule ids from userDefinedSchedules
            const accountGroupIds = this.userDefinedSchedules.map(schedule => schedule.id);
            // Push account classification schedule id to account group array
            if (this.accountClassificationSchedule !== undefined) {
                accountGroupIds.push(this.accountClassificationSchedule.id);
            }
            // Get account group links for given account groups ids for account.
            let categoryNodeAccounts = [];
            this.store.pipe(select(getAccountGroupLinksByGroupIds, {
                accountId: this.initialAccountInformation.id, accountGroupIds,
            }), first(accountGroupsLinksWithGroupId => accountGroupsLinksWithGroupId !== undefined))
                .toPromise().then((accountGroupsLinksWithGroupId) => {
                if (this.accountClassificationSchedule !== undefined) {
                    const links = accountGroupsLinksWithGroupId.find(accountGroupLink => { var _a; return accountGroupLink.accountGroupId === ((_a = this.accountClassificationSchedule) === null || _a === void 0 ? void 0 : _a.id); }).accountGroupLinks;
                    categoryNodeAccounts =
                        this.accountPackagingService
                            .packageCategoryNodeAccountsForAccountClassification(this.editAccountForm, this.allowDebitCreditGroupings, this.initialAccountInformation.id, links === null || links === void 0 ? void 0 : links.categoryNodeAccountsAssigned);
                }
                // Tax Schedule
                this.store.pipe(select(getTaxScheduleLinksForAccount, {
                    accountId: this.initialAccountInformation.id
                }), first()).toPromise().then(taxCodeLinks => {
                    let taxCodeAccounts = [];
                    if (taxCodeLinks !== undefined) {
                        taxCodeAccounts = this.accountPackagingService.packageTaxCodeAccountsForTaxSchedule(this.editAccountForm, this.allowDebitCreditGroupings, this.initialAccountInformation.id, taxCodeLinks.taxCodeAccountsAssigned);
                    }
                    // User defined schedules
                    this.userDefinedSchedules.forEach((schedule) => {
                        const userDefinedLinks = accountGroupsLinksWithGroupId.find(accountGroupLink => accountGroupLink.accountGroupId === schedule.id).accountGroupLinks;
                        categoryNodeAccounts =
                            categoryNodeAccounts.concat(this.accountPackagingService
                                .packageCategoryNodeAccountsForUserDefinedSchedule(this.editAccountForm, this.allowDebitCreditGroupings, schedule.id, this.initialAccountInformation.id, userDefinedLinks === null || userDefinedLinks === void 0 ? void 0 : userDefinedLinks.categoryNodeAccountsAssigned));
                    });
                    const accountNumberFormValue = this.editAccountForm.value.accountNumberControl;
                    const accountDescriptionFormValue = this.editAccountForm.value.accountDescriptionControl;
                    const accountToSave = Object.assign(Object.assign({}, this.initialAccountInformation), { accountNumber: accountNumberFormValue !== '' ? accountNumberFormValue : undefined, description: accountDescriptionFormValue !== '' ? accountDescriptionFormValue : undefined });
                    const accountWithLinksToSave = {
                        account: accountToSave,
                        categoryNodeAccounts,
                        taxCodeAccounts,
                    };
                    // Get the rounding toogle Status
                    const roundIndependently = this.editAccountForm.value.roundIndependentlyControl;
                    const saveAccountObj = {
                        newAccountWithLinks: accountWithLinksToSave,
                        roundIndependently
                    };
                    this.activeModal.close(saveAccountObj);
                });
            });
        }
    }
    /**
     * Dismiss the modal
     */
    cancel() {
        this.activeModal.dismiss();
    }
    // For Meera: Potential Alternative is to put this code in the grouping component and only run it if in edit mode.
    // Which do you like more?
    /**
     * Takes the existing links and populates them into the form
     * @param existingAccountClassificationLinks The existing links for the schedule/account
     * @param scheduleId The ID of the Account Classification Schedule
     */
    setExistingAccountClassificationMappings(existingAccountClassificationLinks, scheduleId) {
        existingAccountClassificationLinks.forEach(accountGroupLink => {
            // For Meera: We're not currently saving the value for the mapping options, just the observable
            // An Alternative would be to save the mappings into a separate object so we can access them here
            this.categoryNodeOptionComboboxObservable[scheduleId].subscribe(mappingOptions => {
                const linkForCategoryNode = mappingOptions.find(option => option.id === accountGroupLink.categoryNodeId);
                if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.AllBalances) {
                    this.editAccountForm.controls.accountClassificationComboboxControl.setValue(linkForCategoryNode);
                }
                else if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.DebitBalances) {
                    this.editAccountForm.controls.accountClassificationDebitComboboxControl.setValue(linkForCategoryNode);
                    this.editAccountForm.controls.accountClassificationBalanceOption.setValue(BmaaBalanceOptions.DebitCredit);
                }
                else if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.CreditBalances) {
                    this.editAccountForm.controls.accountClassificationCreditComboboxControl.setValue(linkForCategoryNode);
                    this.editAccountForm.controls.accountClassificationBalanceOption.setValue(BmaaBalanceOptions.DebitCredit);
                }
            });
        });
    }
    // For Meera: Potential Alternative is to put this code in the grouping component and only run it if in edit mode.
    // Which do you like more?
    /**
     * Takes the existing links and populates them into the form
     * @param existingUserDefinedLinks The existing links for the schedule/account
     * @param scheduleId The id of the user defined schedule
     */
    setExistingUserDefinedScheduleMappings(existingUserDefinedLinks, scheduleId) {
        existingUserDefinedLinks.forEach(accountGroupLink => {
            // For Meera: We're not currently saving the value for the mapping options, just the observable
            // An Alternative would be to save the mappings into a separate object so we can access them here
            this.categoryNodeOptionComboboxObservable[scheduleId].subscribe(mappingOptions => {
                const linkForCategoryNode = mappingOptions.find(option => option.id === accountGroupLink.categoryNodeId);
                if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.AllBalances) {
                    const comboboxControlString = this.bmaaFormStrings.getUserDefinedControl(scheduleId);
                    this.editAccountForm.controls[comboboxControlString].setValue(linkForCategoryNode);
                }
                else if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.DebitBalances) {
                    const comboboxControlString = this.bmaaFormStrings.getUserDefinedDebitControl(scheduleId);
                    const balanceOptionControlString = this.bmaaFormStrings.getUserDefinedTotalBalanceControl(scheduleId);
                    this.editAccountForm.controls[comboboxControlString].setValue(linkForCategoryNode);
                    this.editAccountForm.controls[balanceOptionControlString].setValue(BmaaBalanceOptions.DebitCredit);
                }
                else if (accountGroupLink.totalBalanceCondition === TotalBalanceCondition.CreditBalances) {
                    const comboboxControlString = this.bmaaFormStrings.getUserDefinedCreditControl(scheduleId);
                    const balanceOptionControlString = this.bmaaFormStrings.getUserDefinedTotalBalanceControl(scheduleId);
                    this.editAccountForm.controls[comboboxControlString].setValue(linkForCategoryNode);
                    this.editAccountForm.controls[balanceOptionControlString].setValue(BmaaBalanceOptions.DebitCredit);
                }
            });
        });
    }
    // For Meera: Potential Alternative is to put this code in the grouping component and only run it if in edit mode.
    // Which do you like more?
    /**
     * Takes the existing links and populates them into the form
     * @param existingTaxCodeLinks The existing links for the account
     */
    setExistingTaxScheduleMappings(existingTaxCodeLinks) {
        existingTaxCodeLinks.forEach(taxCodeLink => {
            // For Meera: We're not currently saving the value for the mapping options, just the observable
            // An Alternative would be to save the mappings into a separate object so we can access them here
            this.taxCodeOptionComboboxObservable.subscribe(mappingOptions => {
                const linkForTaxCode = mappingOptions.find(option => option.id === taxCodeLink.taxCodeId);
                if (taxCodeLink.totalBalanceCondition === TotalBalanceCondition.AllBalances) {
                    this.editAccountForm.controls.taxCodeComboboxControl.setValue(linkForTaxCode);
                }
                else if (taxCodeLink.totalBalanceCondition === TotalBalanceCondition.DebitBalances) {
                    this.editAccountForm.controls.taxCodeDebitComboboxControl.setValue(linkForTaxCode);
                    this.editAccountForm.controls.taxScheduleBalanceOption.setValue(BmaaBalanceOptions.DebitCredit);
                }
                else if (taxCodeLink.totalBalanceCondition === TotalBalanceCondition.CreditBalances) {
                    this.editAccountForm.controls.taxCodeCreditComboboxControl.setValue(linkForTaxCode);
                    this.editAccountForm.controls.taxScheduleBalanceOption.setValue(BmaaBalanceOptions.DebitCredit);
                }
            });
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the StatutoryReporting Frp
            this.hasStatutoryReportingFrp = yield this.frpService.hasStatutoryReportingFrp();
            // Loads the allowDebitCredit from the state
            this.store.pipe(select(getAllowDebitCredit), first(allowDebCred => allowDebCred !== undefined))
                .toPromise().then((allowDebCred) => {
                this.allowDebitCreditGroupings = allowDebCred;
            });
            this.store.pipe(select(getAccountToUpdate)).subscribe(acct => {
                if (acct !== undefined) {
                    this.initialAccountInformation = acct;
                    this.editAccountForm.controls.accountNumberControl.setValue(acct.accountNumber);
                    this.editAccountForm.controls.accountDescriptionControl.setValue(acct.description);
                    const propsObj = { accountId: acct.id, tag: BmaaAccountTags.RoundIndependently };
                    this.store.pipe(select(getAccountTagForAccountAndTag, propsObj), first(accountTag => accountTag !== undefined))
                        .toPromise().then(() => {
                        this.editAccountForm.controls.roundIndependentlyControl.setValue(true);
                    });
                }
            });
            this.store.pipe(select(getAccountGroups)).subscribe(accountGroups => {
                if (accountGroups !== undefined) {
                    // Separate out the account classification schedule
                    this.accountClassificationSchedule = accountGroups.find(group => {
                        return group.isStandardAccountClassification;
                    });
                    // Separate out the user defined schedules
                    this.userDefinedSchedules = accountGroups.filter(group => {
                        return !group.isStandardAccountClassification;
                    });
                    if (accountGroups.length > 0) {
                        this.hasAnyGroupings = true;
                    }
                    // Add form controls for each user defined schedule
                    this.userDefinedSchedules.forEach(schedule => {
                        this.editAccountForm.addControl(this.bmaaFormStrings.getUserDefinedControl(schedule.id), new FormControl(null));
                        this.editAccountForm.addControl(this.bmaaFormStrings.getUserDefinedDebitControl(schedule.id), new FormControl(null));
                        this.editAccountForm.addControl(this.bmaaFormStrings.getUserDefinedCreditControl(schedule.id), new FormControl(null));
                        this.editAccountForm.addControl(this.bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule.id), new FormControl(BmaaBalanceOptions.TotalBalance));
                    });
                }
            });
            // Load the tax schedule from the store
            this.store.pipe(select(getTaxScheduleState)).subscribe(taxScheduleState => {
                if (taxScheduleState.taxScheduleLoaded) {
                    this.taxSchedule = taxScheduleState.taxSchedule;
                    if (this.taxSchedule !== undefined && this.taxSchedule !== null) {
                        this.hasAnyGroupings = true;
                    }
                }
            });
            // Load the mapping options from the state and when they're loaded, set the observable for the combobox
            this.store.pipe(select(getTaxCodeMappingOptionState)).subscribe(taxCodeOptionState => {
                if (taxCodeOptionState.taxCodeOptionsLoaded) {
                    this.taxCodeOptionComboboxObservable = this.store.pipe(select(getTaxCodeOptions));
                    // For Meera: Potential Alternative is to put this code in the grouping component and only run it if in edit mode.
                    // Which do you like more?
                    this.store.pipe(select(getTaxScheduleLinksForAccount, {
                        accountId: this.initialAccountInformation.id
                    })).subscribe(links => {
                        if (links !== undefined) {
                            this.setExistingTaxScheduleMappings(links.taxCodeAccountsAssigned);
                        }
                    });
                }
            });
        });
    }
}
EditAccountModalComponent.ɵfac = function EditAccountModalComponent_Factory(t) { return new (t || EditAccountModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.FormBuilder), ɵngcc0.ɵɵdirectiveInject(BmaaDuplicateAccountNumberValidator), ɵngcc0.ɵɵdirectiveInject(BmaaDuplicateAccountDescriptionValidator), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store), ɵngcc0.ɵɵdirectiveInject(AccountPackagingService), ɵngcc0.ɵɵdirectiveInject(AccountFrpService)); };
EditAccountModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditAccountModalComponent, selectors: [["bmaa-edit-account-modal"]], decls: 29, vars: 22, consts: [[1, "bmaa-modal"], [3, "formGroup"], ["type", "button", "aria-hidden", "true", 1, "close", 3, "click"], [1, "bento-icon-close-x"], [1, "modal-header", "bmaa-header-title"], [1, "modal-body"], ["modalBody", ""], [1, "form-horizontal"], ["class", "form-group", 4, "ngIf"], [3, "addEditAccountForm"], [3, "isEditModal", "addEditAccountForm", 4, "ngIf"], [1, "form-group"], [1, "col-md-12"], [3, "schedule", "modalBodyReference", "optionsObservable", "addEditAccountForm", "balanceOptionFormControlName", "totalBalanceComboboxControlName", "debitComboboxControlName", "creditComboboxControlName", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "click"], ["type", "button", 1, "btn", "btn-default", 3, "click"], ["role", "alert", 1, "alert", "bento-alert", "alert-danger"], [1, "bmaa-alert-text", 3, "translate"], [3, "isEditModal", "addEditAccountForm"], [2, "font-size", "16px", 3, "translate"], [3, "schedule", "modalBodyReference", "optionsObservable", "addEditAccountForm", "balanceOptionFormControlName", "totalBalanceComboboxControlName", "debitComboboxControlName", "creditComboboxControlName"]], template: function EditAccountModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "form", 1)(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function EditAccountModalComponent_Template_button_click_2_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5, 6)(9, "div", 7);
        ɵngcc0.ɵɵtemplate(10, EditAccountModalComponent_div_10_Template, 4, 3, "div", 8);
        ɵngcc0.ɵɵelement(11, "bmaa-account-number-form", 9)(12, "bmaa-account-description-form", 9);
        ɵngcc0.ɵɵtemplate(13, EditAccountModalComponent_bmaa_round_independently_form_13_Template, 1, 2, "bmaa-round-independently-form", 10);
        ɵngcc0.ɵɵelementStart(14, "div", 11);
        ɵngcc0.ɵɵelement(15, "div", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, EditAccountModalComponent_div_16_Template, 3, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(17, EditAccountModalComponent_bmaa_account_grouping_form_17_Template, 1, 8, "bmaa-account-grouping-form", 13);
        ɵngcc0.ɵɵtemplate(18, EditAccountModalComponent_bmaa_account_grouping_form_18_Template, 1, 8, "bmaa-account-grouping-form", 13);
        ɵngcc0.ɵɵtemplate(19, EditAccountModalComponent_div_19_Template, 2, 8, "div", 14);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(20, "div", 15)(21, "button", 16);
        ɵngcc0.ɵɵlistener("click", function EditAccountModalComponent_Template_button_click_21_listener() { return ctx.saveUpdatedAccount(); });
        ɵngcc0.ɵɵelementStart(22, "span");
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵpipe(24, "translate");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(25, "button", 17);
        ɵngcc0.ɵɵlistener("click", function EditAccountModalComponent_Template_button_click_25_listener() { return ctx.cancel(); });
        ɵngcc0.ɵɵelementStart(26, "span");
        ɵngcc0.ɵɵtext(27);
        ɵngcc0.ɵɵpipe(28, "translate");
        ɵngcc0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.editAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.cancel.top");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 16, "bmaa_common_editAccount"), " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editAccountForm.hasError(ctx.bmaaFormStrings.NUMBER_DESCRIPTION_REQUIRED_ERROR));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("addEditAccountForm", ctx.editAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("addEditAccountForm", ctx.editAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasStatutoryReportingFrp);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAnyGroupings);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accountClassificationSchedule !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.taxSchedule !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.userDefinedSchedules);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.editAccountForm.valid || ctx.editAccountForm.value.accountNumberControl === "" && ctx.editAccountForm.value.accountDescriptionControl === "");
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.save");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(24, 18, "bmaa_addEditAccount_saveClose"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.cancel");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(28, 20, "bmaa_common_cancel"));
    } }, directives: function () { return [ɵngcc2.ɵNgNoValidate, ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc6.BentoFocusMonitorDirective, ɵngcc3.NgIf, ɵngcc4.TranslateDirective, AccountNumberFormComponent, AccountDescriptionFormComponent, RoundIndependentlyFormComponent, AccountGroupingFormComponent, ɵngcc3.NgForOf, ɵngcc6.BentoFooterTabHelper]; }, pipes: function () { return [ɵngcc4.TranslatePipe]; }, styles: [".bmaa-modal[_ngcontent-%COMP%]   .bmaa-alert-text[_ngcontent-%COMP%]{margin-left:25px}.bmaa-modal[_ngcontent-%COMP%]   .bmaa-header-title[_ngcontent-%COMP%]{justify-content:left}"] });
EditAccountModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: FormBuilder },
    { type: BmaaDuplicateAccountNumberValidator },
    { type: BmaaDuplicateAccountDescriptionValidator },
    { type: Store },
    { type: AccountPackagingService },
    { type: AccountFrpService }
];

const ɵ0$b = (state) => state.periodState;
const getPeriodState = createSelector(getAddAccountState, ɵ0$b);
const ɵ1$9 = (state) => state.periods;
const getPeriods = createSelector(getPeriodState, ɵ1$9);
const ɵ2$9 = (state) => state.periodsLoading;
const getPeriodsLoading = createSelector(getPeriodState, ɵ2$9);
const ɵ3$9 = (state) => state.periodsLoaded;
const getPeriodsLoaded = createSelector(getPeriodState, ɵ3$9);
const ɵ4$9 = (state) => state.periodsLoadingFailed;
const getPeriodsLoadingFailed = createSelector(getPeriodState, ɵ4$9);
const ɵ5$5 = (state) => state.periods.find(period => period.isCurrentPeriod);
const getCurrentPeriod = createSelector(getPeriodState, ɵ5$5);

const ɵ0$c = (state) => state.fiscalYearState;
const getFiscalYearState = createSelector(getAddAccountState, ɵ0$c);
const ɵ1$a = (state) => state.fiscalYears;
const getFiscalYears = createSelector(getFiscalYearState, ɵ1$a);
const ɵ2$a = (state) => state.fiscalYearsLoading;
const getFiscalYearsLoading = createSelector(getFiscalYearState, ɵ2$a);
const ɵ3$a = (state) => state.fiscalYearsLoaded;
const getFiscalYearsLoaded = createSelector(getFiscalYearState, ɵ3$a);
const ɵ4$a = (state) => state.fiscalYearsLoadingFailed;
const getFiscalYearsLoadingFailed = createSelector(getFiscalYearState, ɵ4$a);
const ɵ5$6 = (years, currentPeriod) => {
    if (currentPeriod !== undefined) {
        const currentFiscalYear = years.find(year => year.id === currentPeriod.fiscalYearId);
        return currentFiscalYear;
    }
};
const getCurrentFiscalYear = createSelector(getFiscalYears, getCurrentPeriod, ɵ5$6);
const ɵ6$4 = (years, currentFiscalYear) => {
    if (currentFiscalYear !== undefined) {
        const priorFiscalYear = years.find(year => year.sequenceNumber === currentFiscalYear.sequenceNumber - 1);
        return priorFiscalYear;
    }
};
const getPriorFiscalYear = createSelector(getFiscalYears, getCurrentFiscalYear, ɵ6$4);
const ɵ7$2 = (years, currentFiscalYear) => {
    if (currentFiscalYear !== undefined) {
        const priorFiscalYear = years.find(year => year.sequenceNumber === currentFiscalYear.sequenceNumber + 1);
        return priorFiscalYear;
    }
};
const getNextFiscalYear = createSelector(getFiscalYears, getCurrentFiscalYear, ɵ7$2);
const ɵ8$1 = (currentFiscalYear, periods) => {
    if (currentFiscalYear !== undefined) {
        return periods.find(period => period.fiscalYearId === currentFiscalYear.id && period.sequenceNumber === 1);
    }
};
const getFirstPeriodOfCurrentFiscalYear = createSelector(getCurrentFiscalYear, getPeriods, ɵ8$1);
const ɵ9$1 = (nextFiscalYear, periods) => {
    if (nextFiscalYear !== undefined) {
        return periods.find(period => period.fiscalYearId === nextFiscalYear.id && period.sequenceNumber === 1);
    }
};
const getFirstPeriodOfNextFiscalYear = createSelector(getNextFiscalYear, getPeriods, ɵ9$1);

/**
 * The accounting group type
 */
var AccountingGroupType;
(function (AccountingGroupType) {
    AccountingGroupType["ACCOUNTCLASSIFICATION"] = "ACCOUNTCLASSIFICATION";
})(AccountingGroupType || (AccountingGroupType = {}));

class AddAccountComponent {
    constructor(store, modalService, accountService, trialBalanceService, localeService, frpService) {
        this.store = store;
        this.modalService = modalService;
        this.accountService = accountService;
        this.trialBalanceService = trialBalanceService;
        this.localeService = localeService;
        this.frpService = frpService;
        this.accountAdded = new EventEmitter();
        this.accountAddedTrialBalance = new EventEmitter();
        this.accountUpdated = new EventEmitter();
        this.accountUpdatedTrialBalance = new EventEmitter();
        this.modalClose = new EventEmitter();
        this.modalCancel = new EventEmitter();
    }
    /**
     * Saves the newly added account to the database. Chooses endpoint based on whether or not there is a trialBalanceGridId
     * @param accountToSave The new AccountWithLinks to save
     */
    saveNewAccount(accountToSave, roundIndependently) {
        if (this.passedInData.trialBalanceGridId === undefined) {
            this.accountService.addAccount(this.ownerId, [accountToSave]).subscribe((newAccount) => {
                this.accountAdded.emit(newAccount);
                this.store.dispatch(new AddNewAccount({ newAccount: newAccount[0].account }));
                // If the roundIndependently is true save account tag
                if (roundIndependently) {
                    this.saveAccountTag(newAccount[0].account);
                }
            });
        }
        else {
            const trialBalanceAccount = {
                trialBalanceGridIds: [this.passedInData.trialBalanceGridId],
                account: accountToSave.account,
                categoryNodeAccounts: accountToSave.categoryNodeAccounts,
                taxCodeAccounts: accountToSave.taxCodeAccounts,
            };
            this.trialBalanceService.addAccount(this.ownerId, trialBalanceAccount).subscribe((newAccountGridData) => {
                this.accountAddedTrialBalance.emit({
                    newAccount: newAccountGridData[0],
                    categoryNodeMappings: trialBalanceAccount.categoryNodeAccounts,
                    taxCodeMappings: trialBalanceAccount.taxCodeAccounts
                });
                const savedAccount = {
                    ownerId: this.ownerId,
                    accountNumber: accountToSave.account.accountNumber,
                    description: accountToSave.account.description,
                    id: newAccountGridData[0].currentPageItems[0].id,
                };
                this.store.dispatch(new AddNewAccount({ newAccount: savedAccount }));
                // If the roundIndependently is true save account tag
                if (roundIndependently) {
                    this.saveAccountTag(savedAccount);
                }
            });
        }
    }
    /**
     * Saves the accountTags to the database.
     * @param savedAccount Newly account object which is saved
     */
    saveAccountTag(savedAccount) {
        const saveAccountTags = [
            {
                tag: BmaaAccountTags.RoundIndependently,
                isSystemTag: false,
                accountId: savedAccount.id,
                validFromDate: this.period.startDate,
                validToDate: this.fiscalYear.endDate
            },
            {
                tag: BmaaAccountTags.RoundIndependentlyInitial,
                isSystemTag: false,
                accountId: savedAccount.id,
                validFromDate: this.period.startDate,
                validToDate: this.fiscalYear.endDate
            },
        ];
        // Add roundIndependently and roundIdependentlyInitial tag
        this.store.dispatch(new AddAccountTags({ ownerId: this.ownerId, newAccountTags: saveAccountTags }));
    }
    /**
     * Saves the newly updated account to the database. Chooses endpoint based on whether or not there is a trialBalanceGridId
     * @param accountToUpdate AccountWithLinks to save
     */
    updateAccount(accountToUpdate) {
        if (this.passedInData.trialBalanceGridId === undefined) {
            if (this.localeService.isCurrentCountryUK() || this.localeService.isCurrentCountryAR()) {
                this.store.pipe(select(getCurrentFiscalYear), take(1)).toPromise().then(fiscalYear => {
                    this.accountService.updateAccount(this.ownerId, accountToUpdate, fiscalYear.id)
                        .toPromise().then(editedAccount => {
                        this.accountUpdated.emit(editedAccount);
                        this.store.dispatch(new UpdateAccount({ updatedAccount: editedAccount.account }));
                    });
                });
            }
            else {
                this.accountService.updateAccount(this.ownerId, accountToUpdate)
                    .toPromise().then(editedAccount => {
                    this.accountUpdated.emit(editedAccount);
                    this.store.dispatch(new UpdateAccount({ updatedAccount: editedAccount.account }));
                });
            }
        }
        else {
            const trialBalanceAccount = {
                trialBalanceGridIds: [this.passedInData.trialBalanceGridId],
                account: accountToUpdate.account,
                categoryNodeAccounts: accountToUpdate.categoryNodeAccounts,
                taxCodeAccounts: accountToUpdate.taxCodeAccounts,
            };
            // If the country code is UK or AR, send the fiscal year id to save account description per year
            if (this.localeService.isCurrentCountryUK() || this.localeService.isCurrentCountryAR()) {
                this.store.pipe(select(getCurrentFiscalYear), take(1)).toPromise().then(fiscalYear => {
                    this.trialBalanceService.updateAccount(this.ownerId, trialBalanceAccount, fiscalYear.id)
                        .toPromise().then((updatedAccountGridData) => {
                        this.updateAccountTrialBalance(updatedAccountGridData, trialBalanceAccount, accountToUpdate);
                    });
                });
            }
            else {
                this.trialBalanceService.updateAccount(this.ownerId, trialBalanceAccount)
                    .toPromise().then((updatedAccountGridData) => {
                    this.updateAccountTrialBalance(updatedAccountGridData, trialBalanceAccount, accountToUpdate);
                });
            }
        }
    }
    /**
     * Handle round independently accountTag for update account.
     * @param saveAccountObj The save account object with account and rounIndependently
     */
    handleAccountTagForUpdateAccount(saveAccountObj) {
        return __awaiter(this, void 0, void 0, function* () {
            const hasFrp = yield this.frpService.hasStatutoryReportingFrp();
            if (hasFrp) {
                if (saveAccountObj.roundIndependently) {
                    this.addAccountTagForUpdateAccount(saveAccountObj.newAccountWithLinks.account);
                }
                else {
                    this.addOrUpdateAccountTagForUpdateAccount(saveAccountObj.newAccountWithLinks.account);
                }
            }
        });
    }
    /**
     * Add round independently accountTag to the database for edit account.
     * when roundIndependently is set to true
     * @param updatedAccount The updated account object which is saved
     */
    addAccountTagForUpdateAccount(updatedAccount) {
        // If round independently is set to true, then create a new account tag
        if (this.roundIndependentlyTag === undefined) {
            const saveAccountTags = [
                {
                    tag: BmaaAccountTags.RoundIndependently,
                    isSystemTag: false,
                    accountId: updatedAccount.id,
                    validFromDate: this.period.startDate,
                    validToDate: this.fiscalYear.endDate
                },
            ];
            // Add roundIndependently tag
            this.store.dispatch(new AddAccountTags({ ownerId: this.ownerId, newAccountTags: saveAccountTags }));
        }
    }
    /**
     * Add or update round independently accountTag to the database for edit account.
     * when round independently is set to false
     * @param updatedAccount The updated account object which is saved
     */
    addOrUpdateAccountTagForUpdateAccount(updatedAccount) {
        if (this.roundIndependentlyTag !== undefined) {
            // If there is an existing round independently tag for this year or it is single year, delete the tag
            if ((this.roundIndependentlyTag.validFromDate === this.period.startDate
                && this.roundIndependentlyTag.validToDate === this.fiscalYear.endDate)
                || (this.nextFiscalYearFirstPeriod === undefined && this.priorFiscalYear === undefined)) {
                // Delete roundIndependently tag
                this.store.dispatch(new DeleteAccountTags({ ownerId: this.ownerId, deleteAccountTagIds: [this.roundIndependentlyTag.id] }));
            }
            else if (this.roundIndependentlyTag.validFromDate === this.period.startDate) {
                // If there is an existing round independently tag which started this year, but didn't end this year, start the tag from next year
                this.roundIndependentlyTag.validFromDate = this.nextFiscalYearFirstPeriod.startDate;
                // Update roundIndependently tag
                this.store.dispatch(new UpdateAccountTag({ ownerId: this.ownerId, updatedAccountTag: this.roundIndependentlyTag }));
            }
            else if (this.roundIndependentlyTag.validToDate === this.fiscalYear.endDate) {
                // If there is an existing round independently tag which ended this year, but didn't start this year, end the tag in previous year
                this.roundIndependentlyTag.validToDate = this.priorFiscalYear.endDate;
                // Update roundIndependently tag
                this.store.dispatch(new UpdateAccountTag({ ownerId: this.ownerId, updatedAccountTag: this.roundIndependentlyTag }));
            }
            else {
                // Else there is an existing round independently tag started before this year and ended after this year
                // End the current tag in previous year, and create new tag from next year
                const saveAccountTags = [
                    {
                        tag: BmaaAccountTags.RoundIndependently,
                        isSystemTag: false,
                        accountId: updatedAccount.id,
                        validFromDate: this.nextFiscalYearFirstPeriod.startDate,
                        validToDate: this.roundIndependentlyTag.validToDate
                    },
                ];
                // Add roundIndependently tag
                this.store.dispatch(new AddAccountTags({ ownerId: this.ownerId, newAccountTags: saveAccountTags }));
                this.roundIndependentlyTag.validToDate = this.priorFiscalYear.endDate;
                // Update roundIndependently tag
                this.store.dispatch(new UpdateAccountTag({ ownerId: this.ownerId, updatedAccountTag: this.roundIndependentlyTag }));
            }
        }
    }
    /**
     * Emits the updated account trial balance and update the store
     */
    updateAccountTrialBalance(updatedAccountGridData, trialBalanceAccount, accountToUpdate) {
        this.accountUpdatedTrialBalance.emit({
            updatedAccount: updatedAccountGridData[0],
            categoryNodeMappings: trialBalanceAccount.categoryNodeAccounts,
            taxCodeMappings: trialBalanceAccount.taxCodeAccounts
        });
        const savedAccount = {
            ownerId: this.ownerId,
            accountNumber: accountToUpdate.account.accountNumber,
            description: accountToUpdate.account.description,
            id: updatedAccountGridData[0].currentPageItems[0].id,
        };
        this.store.dispatch(new UpdateAccount({ updatedAccount: savedAccount }));
    }
    /**
     * Opens the add account modal
     */
    openAddAccountModal() {
        const modal = this.modalService.open(AddAccountModalComponent, {
            container: '#bentoNGModalContainer',
            keyboard: false,
            backdrop: 'static',
        });
        // If we close/cancel the modal, we need to tell the parent
        modal.result.then(() => {
            this.modalClose.emit();
        }, () => {
            this.modalCancel.emit();
        });
        // The modal emits a saveAccount event, and this handler calls saveNewAccount when it's done
        modal.componentInstance.saveAccount.subscribe((saveAccountObj) => {
            this.saveNewAccount(saveAccountObj.newAccountWithLinks, saveAccountObj.roundIndependently);
        });
    }
    /**
     * Opens the add account modal
     */
    openEditAccountModal() {
        const modal = this.modalService.open(EditAccountModalComponent, {
            container: '#bentoNGModalContainer',
            keyboard: false,
            backdrop: 'static',
        });
        // If we close/cancel the modal, we need to tell the parent
        modal.result.then((saveAccountObj) => {
            this.updateAccount(saveAccountObj.newAccountWithLinks);
            this.handleAccountTagForUpdateAccount(saveAccountObj);
            this.modalClose.emit();
        }, () => {
            this.modalCancel.emit();
        });
    }
    // Loads data into stores by dispatching load or set actions
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const isAccountsApplication = this.passedInData.applicationType === ApplicationType.Accounts;
            // Saves in flags for the modals
            this.store.dispatch(new SetAddAccountSettings({
                defaultFirstGrouping: this.passedInData.defaultFirstGrouping,
                allowDebitCredit: this.passedInData.allowDebitCredit,
                applicationType: this.passedInData.applicationType,
                ownerId: this.ownerId,
                accountToUpdate: this.accountToEdit,
                isEquityAccountModal: this.passedInData.isEquityAccountModal,
            }));
            // Saves accounts in the store either by loading from the database or passing in what's passed into the modal
            if (this.passedInData.accounts === undefined) {
                this.store.dispatch(new LoadAccounts({ ownerId: this.ownerId }));
            }
            else {
                this.store.dispatch(new SetAccounts({ accounts: this.passedInData.accounts }));
            }
            // Saves account groups in the store either by loading from the database or passing in what's passed into the modal
            if (this.passedInData.groupingSchedules === undefined) {
                this.store.pipe(select(getCurrentFiscalYear), first(fiscalYear => fiscalYear !== undefined)).toPromise().then(fiscalYear => {
                    this.store.dispatch(new LoadAccountGroups({ ownerId: this.ownerId, fiscalYearId: fiscalYear.id, isAccountsApplication }));
                });
            }
            else {
                const accountGroupData = isAccountsApplication ?
                    this.passedInData.groupingSchedules.filter(accountGroup => accountGroup.systemId !== AccountingGroupType.ACCOUNTCLASSIFICATION) : this.passedInData.groupingSchedules;
                this.store.dispatch(new SetAccountGroups({ accountGroups: accountGroupData }));
            }
            // Saves fiscalYears in the store either by loading from the database or what's passed into payload.
            if (this.passedInData.fiscalYears === undefined) {
                this.store.dispatch(new LoadFiscalYears({ ownerId: this.ownerId }));
            }
            else {
                this.store.dispatch(new SetFiscalYears({ fiscalyears: this.passedInData.fiscalYears }));
            }
            if (this.accountToEdit !== undefined) {
                // Saves accountTags in the store either by loading from the database or passing in what's passed into the modal
                if (this.passedInData.accountTags === undefined) {
                    this.store.pipe(select(getCurrentFiscalYear), first(fiscalYear => fiscalYear !== undefined)).toPromise().then(fiscalYear => {
                        this.store.dispatch(new LoadAccountTags({ ownerId: this.ownerId, dateToCheck: fiscalYear.endDate }));
                    });
                }
                else {
                    this.store.dispatch(new SetAccountsTags({ accountTags: this.passedInData.accountTags }));
                }
            }
            // Saves periods in the store either by loading from the database or what's passed into payload
            if (this.passedInData.periods === undefined) {
                this.store.dispatch(new LoadPeriods({ ownerId: this.ownerId }));
            }
            else {
                this.store.dispatch(new SetPeriods({ periods: this.passedInData.periods }));
            }
            // Listens for changes to the accountGroup state to capture when they're loaded in
            this.store.pipe(select(getAccountGroupState), first(state => state.accountGroupsLoaded))
                .toPromise()
                .then(accountGroupState => {
                if (accountGroupState.accountGroupsLoaded) {
                    // Gets the category node mapping options for each account group the user has
                    accountGroupState.accountGroups.forEach(accountGroup => {
                        if (this.passedInData.categoryNodeMappingOptions === undefined ||
                            this.passedInData.categoryNodeMappingOptions[accountGroup.id] === undefined) {
                            this.store.dispatch(new LoadCategoryNodeMappingOptions({ ownerId: this.ownerId, accountGroupId: accountGroup.id }));
                        }
                        else {
                            this.store.dispatch(new SetCategoryNodeMappingOptions({
                                accountGroupId: accountGroup.id,
                                categoryNodeOptions: this.passedInData.categoryNodeMappingOptions[accountGroup.id]
                            }));
                        }
                        // Gets the linked accounts for each account group the user has
                        if (this.passedInData.existingCategoryNodeAccountMappings === undefined ||
                            this.passedInData.existingCategoryNodeAccountMappings[accountGroup.id] === undefined) {
                            this.store.dispatch(new LoadAccountWithAccountGroupLinks({ ownerId: this.ownerId, accountGroupId: accountGroup.id }));
                        }
                        else {
                            this.store.dispatch(new SetAccountWithAccountGroupLinks({
                                accountGroupId: accountGroup.id,
                                accountLinks: [{
                                        account: this.accountToEdit,
                                        categoryNodeAccountsAssigned: this.passedInData.existingCategoryNodeAccountMappings[accountGroup.id],
                                    }]
                            }));
                        }
                    });
                }
            });
            // Saves tax schedule in the store either by loading from the database or passing in what's passed into the modal
            if (this.passedInData.taxSchedule === undefined) {
                this.store.dispatch(new LoadTaxSchedules({ ownerId: this.ownerId }));
            }
            else {
                this.store.dispatch(new SetTaxSchedule({ taxSchedule: this.passedInData.taxSchedule }));
            }
            // Listens for changes to the taxSchedule state to capture when they're loaded in
            this.store.pipe(select(getTaxScheduleState), first(state => state.taxScheduleLoaded))
                .toPromise()
                .then(taxScheduleState => {
                if (taxScheduleState.taxScheduleLoaded) {
                    // Gets the tax code mapping options for the tax schedule
                    if (this.passedInData.taxCodeMappingOptions === undefined) {
                        this.store.dispatch(new LoadTaxCodeMappingOptions({ ownerId: this.ownerId, taxScheduleId: taxScheduleState.taxSchedule.id }));
                    }
                    else {
                        this.store.dispatch(new SetTaxCodeMappingOptions({ taxCodeOptions: this.passedInData.taxCodeMappingOptions }));
                    }
                    // Gets the linked accounts for the tax schedule
                    if (this.passedInData.existingTaxCodeMappings === undefined) {
                        this.store.dispatch(new LoadAccountWithTaxScheduleLinks({ ownerId: this.ownerId, taxScheduleId: taxScheduleState.taxSchedule.id }));
                    }
                    else {
                        this.store.dispatch(new SetAccountWithTaxScheduleLinks({
                            accountsWithTaxLinks: [{
                                    account: this.accountToEdit,
                                    taxCodeAccountsAssigned: this.passedInData.existingTaxCodeMappings,
                                }]
                        }));
                    }
                }
            });
            // Get current fiscalYear and store in variable
            this.store.pipe(select(getCurrentFiscalYear), first(fiscalYear => fiscalYear !== undefined))
                .toPromise()
                .then(fiscalYear => {
                this.fiscalYear = fiscalYear;
            });
            // Get period from fiscalYear
            this.store.pipe(select(getFirstPeriodOfCurrentFiscalYear), first(period => period !== undefined))
                .toPromise()
                .then(period => {
                this.period = period;
            });
            // Get prior fiscalYear and store in variable
            this.store.pipe(select(getPriorFiscalYear), first(fiscalYear => fiscalYear !== undefined))
                .toPromise()
                .then(fiscalYear => {
                this.priorFiscalYear = fiscalYear;
            });
            // Get first period from next fiscalYear
            this.store.pipe(select(getFirstPeriodOfNextFiscalYear), first(period => period !== undefined))
                .toPromise()
                .then(period => {
                this.nextFiscalYearFirstPeriod = period;
            });
            // Get round independently tag for edit account
            this.store.pipe(select(getRoundIndependentlyTagForEditAccount), first(accountTag => accountTag !== undefined))
                .toPromise()
                .then(accountTag => {
                this.roundIndependentlyTag = accountTag;
            });
            // setting the current country code in localeService
            yield this.localeService.setCountryCode();
            if (this.accountToEdit === undefined) {
                this.openAddAccountModal();
            }
            else {
                this.openEditAccountModal();
            }
        });
    }
    ngOnDestroy() {
        this.store.dispatch(new ResetStore());
    }
}
AddAccountComponent.ɵfac = function AddAccountComponent_Factory(t) { return new (t || AddAccountComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.AccountService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.TrialBalanceService), ɵngcc0.ɵɵdirectiveInject(AccountLocaleService), ɵngcc0.ɵɵdirectiveInject(AccountFrpService)); };
AddAccountComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AddAccountComponent, selectors: [["bmaa-add-account"]], inputs: { ownerId: "ownerId", passedInData: "passedInData", accountToEdit: "accountToEdit" }, outputs: { accountAdded: "accountAdded", accountAddedTrialBalance: "accountAddedTrialBalance", accountUpdated: "accountUpdated", accountUpdatedTrialBalance: "accountUpdatedTrialBalance", modalClose: "modalClose", modalCancel: "modalCancel" }, decls: 1, vars: 0, template: function AddAccountComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, styles: [""] });
AddAccountComponent.ctorParameters = () => [
    { type: Store },
    { type: NgbModal },
    { type: AccountService },
    { type: TrialBalanceService },
    { type: AccountLocaleService },
    { type: AccountFrpService }
];
AddAccountComponent.propDecorators = {
    ownerId: [{ type: Input }],
    passedInData: [{ type: Input }],
    accountToEdit: [{ type: Input }],
    accountAdded: [{ type: Output }],
    accountAddedTrialBalance: [{ type: Output }],
    accountUpdated: [{ type: Output }],
    accountUpdatedTrialBalance: [{ type: Output }],
    modalClose: [{ type: Output }],
    modalCancel: [{ type: Output }]
};

class AccountEffects {
    constructor(actions$, accountService) {
        this.actions$ = actions$;
        this.accountService = accountService;
        // Calls the account service to load the accounts
        this.loadAccounts$ = this.actions$.pipe(ofType(AccountActionTypes.LoadAccounts), concatMap((action) => this.accountService.getAll(action.payload.ownerId).pipe(map(data => new LoadAccountsSuccess({ data })), catchError(error => of(new LoadAccountsFailure({ error }))))));
    }
}
AccountEffects.ɵfac = function AccountEffects_Factory(t) { return new (t || AccountEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.AccountService)); };
AccountEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountEffects, factory: AccountEffects.ɵfac });
AccountEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AccountEffects.prototype, "loadAccounts$", void 0);

class FiscalYearEffects {
    constructor(actions$, fiscalYearService) {
        this.actions$ = actions$;
        this.fiscalYearService = fiscalYearService;
        this.loadFiscalYears$ = this.actions$.pipe(ofType(FiscalYearActionTypes.LoadFiscalYears), concatMap((action) => 
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        this.fiscalYearService.get(action.payload.ownerId).pipe(map((data) => {
            const sortedYears = [...data].sort((y1, y2) => y1.sequenceNumber - y2.sequenceNumber);
            return new LoadFiscalYearsSuccess({ data: sortedYears });
        }), catchError(error => of(new LoadFiscalYearsFailure({ error }))))));
    }
}
FiscalYearEffects.ɵfac = function FiscalYearEffects_Factory(t) { return new (t || FiscalYearEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.FiscalYearService)); };
FiscalYearEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: FiscalYearEffects, factory: FiscalYearEffects.ɵfac });
FiscalYearEffects.ctorParameters = () => [
    { type: Actions },
    { type: FiscalYearService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], FiscalYearEffects.prototype, "loadFiscalYears$", void 0);

class PeriodEffects {
    constructor(actions$, periodService) {
        this.actions$ = actions$;
        this.periodService = periodService;
        this.loadPeriods$ = this.actions$.pipe(ofType(PeriodActionTypes.LoadPeriods), concatMap((action) => this.periodService.get(action.payload.ownerId, PeriodType.Accounting).pipe(map(data => new LoadPeriodsSuccess({ data })), catchError(error => of(new LoadPeriodsFailure({ error }))))));
    }
}
PeriodEffects.ɵfac = function PeriodEffects_Factory(t) { return new (t || PeriodEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.PeriodService)); };
PeriodEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PeriodEffects, factory: PeriodEffects.ɵfac });
PeriodEffects.ctorParameters = () => [
    { type: Actions },
    { type: PeriodService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], PeriodEffects.prototype, "loadPeriods$", void 0);

class AccountTagEffects {
    constructor(actions$, accountTagService) {
        this.actions$ = actions$;
        this.accountTagService = accountTagService;
        // Calls the account service to load the accounts-tags
        this.LoadAccountTags$ = this.actions$.pipe(ofType(AccountTagActionTypes.LoadAccountTags), concatMap((action) => this.accountTagService.getAccountTags(action.payload.ownerId, action.payload.dateToCheck).pipe(map(data => new LoadAccountTagsSuccess({ data })), catchError(error => of(new LoadAccountTagsFailure({ error }))))));
        this.addAccountTags$ = this.actions$.pipe(ofType(AccountTagActionTypes.AddAccountTags), concatMap((action) => this.accountTagService.addAccountTags(action.payload.ownerId, action.payload.newAccountTags)));
        this.updateAccountTag$ = this.actions$.pipe(ofType(AccountTagActionTypes.UpdateAccountTag), concatMap((action) => this.accountTagService.updateAccountTag(action.payload.ownerId, action.payload.updatedAccountTag)));
        this.deleteAccountTags$ = this.actions$.pipe(ofType(AccountTagActionTypes.DeleteAccountTags), concatMap((action) => this.accountTagService.deleteAccountTags(action.payload.ownerId, action.payload.deleteAccountTagIds)));
    }
}
AccountTagEffects.ɵfac = function AccountTagEffects_Factory(t) { return new (t || AccountTagEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.AccountTagService)); };
AccountTagEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountTagEffects, factory: AccountTagEffects.ɵfac });
AccountTagEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountTagService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AccountTagEffects.prototype, "LoadAccountTags$", void 0);
__decorate([
    Effect({ dispatch: false }),
    __metadata("design:type", Object)
], AccountTagEffects.prototype, "addAccountTags$", void 0);
__decorate([
    Effect({ dispatch: false }),
    __metadata("design:type", Object)
], AccountTagEffects.prototype, "updateAccountTag$", void 0);
__decorate([
    Effect({ dispatch: false }),
    __metadata("design:type", Object)
], AccountTagEffects.prototype, "deleteAccountTags$", void 0);

class AccountGroupEffects {
    constructor(actions$, accountGroupService) {
        this.actions$ = actions$;
        this.accountGroupService = accountGroupService;
        // Calls the account group service to load the grouping schedules
        this.loadAccountGroups$ = this.actions$.pipe(ofType(AccountGroupActionTypes.LoadAccountGroups), concatMap((action) => this.accountGroupService.get(action.payload.ownerId, action.payload.fiscalYearId).pipe(map((data) => {
            // Hide the Account Classification for UK Accounts application.
            // This will be removed when the group is removed from back-end
            const accountGroupData = action.payload.isAccountsApplication ? data.filter(accountGroup => accountGroup.systemId !== AccountingGroupType.ACCOUNTCLASSIFICATION) : data;
            return new LoadAccountGroupsSuccess({ data: accountGroupData });
        }), catchError(error => of(new LoadAccountGroupsFailure({ error }))))));
    }
}
AccountGroupEffects.ɵfac = function AccountGroupEffects_Factory(t) { return new (t || AccountGroupEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.AccountGroupService)); };
AccountGroupEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountGroupEffects, factory: AccountGroupEffects.ɵfac });
AccountGroupEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountGroupService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AccountGroupEffects.prototype, "loadAccountGroups$", void 0);

class TaxScheduleEffects {
    constructor(actions$, taxScheduleService) {
        this.actions$ = actions$;
        this.taxScheduleService = taxScheduleService;
        // Load the tax schedule for ownerId from the server
        this.loadTaxSchedules$ = this.actions$.pipe(ofType(TaxScheduleActionTypes.LoadTaxSchedules), concatMap((action) => this.taxScheduleService.get(action.payload.ownerId).pipe(map(data => new LoadTaxSchedulesSuccess({ data })), catchError(error => of(new LoadTaxSchedulesFailure({}))))));
    }
}
TaxScheduleEffects.ɵfac = function TaxScheduleEffects_Factory(t) { return new (t || TaxScheduleEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.TaxScheduleService)); };
TaxScheduleEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TaxScheduleEffects, factory: TaxScheduleEffects.ɵfac });
TaxScheduleEffects.ctorParameters = () => [
    { type: Actions },
    { type: TaxScheduleService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], TaxScheduleEffects.prototype, "loadTaxSchedules$", void 0);

class TaxCodeMappingOptionEffects {
    constructor(actions$, taxCodeService) {
        this.actions$ = actions$;
        this.taxCodeService = taxCodeService;
        // Load the mapping options for taxScheduleId from the server
        this.loadTaxCodeMappingOptions$ = this.actions$.pipe(ofType(TaxCodeMappingOptionActionTypes.LoadTaxCodeMappingOptions), concatMap((action) => this.taxCodeService.getSortedMappingOptions(action.payload.ownerId, action.payload.taxScheduleId).pipe(map(data => new LoadTaxCodeMappingOptionsSuccess({ data })), catchError(error => of(new LoadTaxCodeMappingOptionsFailure({}))))));
    }
}
TaxCodeMappingOptionEffects.ɵfac = function TaxCodeMappingOptionEffects_Factory(t) { return new (t || TaxCodeMappingOptionEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.TaxCodeService)); };
TaxCodeMappingOptionEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TaxCodeMappingOptionEffects, factory: TaxCodeMappingOptionEffects.ɵfac });
TaxCodeMappingOptionEffects.ctorParameters = () => [
    { type: Actions },
    { type: TaxCodeService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], TaxCodeMappingOptionEffects.prototype, "loadTaxCodeMappingOptions$", void 0);

class CategoryNodeMappingOptionEffects {
    constructor(actions$, categoryNodeService) {
        this.actions$ = actions$;
        this.categoryNodeService = categoryNodeService;
        // Loads the mapping options for accountGroupId from the server
        this.loadCategoryNodeMappingOptions$ = this.actions$.pipe(ofType(CategoryNodeMappingOptionActionTypes.LoadCategoryNodeMappingOptions), concatMap((action) => this.categoryNodeService.getMappingOptions(action.payload.ownerId, action.payload.accountGroupId).pipe(map((data) => new LoadCategoryNodeMappingOptionsSuccess({ data, accountGroupId: action.payload.accountGroupId })), catchError(() => of(new LoadCategoryNodeMappingOptionsFailure({ accountGroupId: action.payload.accountGroupId }))))));
    }
}
CategoryNodeMappingOptionEffects.ɵfac = function CategoryNodeMappingOptionEffects_Factory(t) { return new (t || CategoryNodeMappingOptionEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.CategoryNodeService)); };
CategoryNodeMappingOptionEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CategoryNodeMappingOptionEffects, factory: CategoryNodeMappingOptionEffects.ɵfac });
CategoryNodeMappingOptionEffects.ctorParameters = () => [
    { type: Actions },
    { type: CategoryNodeService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], CategoryNodeMappingOptionEffects.prototype, "loadCategoryNodeMappingOptions$", void 0);

class AccountWithAccountGroupLinkEffects {
    constructor(actions$, accountService) {
        this.actions$ = actions$;
        this.accountService = accountService;
        // Calls the account service to load the account links for account group with id accountGroupId
        this.loadAccountWithAccountGroupLinks$ = this.actions$.pipe(ofType(AccountWithAccountGroupLinkActionTypes.LoadAccountWithAccountGroupLinks), concatMap((action) => this.accountService.getByAccountGroup(action.payload.ownerId, action.payload.accountGroupId).pipe(map(data => new LoadAccountWithAccountGroupLinksSuccess({ data, accountGroupId: action.payload.accountGroupId })), catchError(error => of(new LoadAccountWithAccountGroupLinksFailure({ accountGroupId: action.payload.accountGroupId }))))));
    }
}
AccountWithAccountGroupLinkEffects.ɵfac = function AccountWithAccountGroupLinkEffects_Factory(t) { return new (t || AccountWithAccountGroupLinkEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.AccountService)); };
AccountWithAccountGroupLinkEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountWithAccountGroupLinkEffects, factory: AccountWithAccountGroupLinkEffects.ɵfac });
AccountWithAccountGroupLinkEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AccountWithAccountGroupLinkEffects.prototype, "loadAccountWithAccountGroupLinks$", void 0);

class AccountWithTaxScheduleLinkEffects {
    constructor(actions$, accountService) {
        this.actions$ = actions$;
        this.accountService = accountService;
        // Use accountService to load the account links for taxScheduleId
        this.loadAccountWithTaxScheduleLinks$ = this.actions$.pipe(ofType(AccountWithTaxScheduleLinkActionTypes.LoadAccountWithTaxScheduleLinks), concatMap((action) => 
        /** An EMPTY observable only emits completion. Replace with your own observable API request */
        this.accountService.getByTaxSchedule(action.payload.ownerId, action.payload.taxScheduleId).pipe(map(data => new LoadAccountWithTaxScheduleLinksSuccess({ data })), catchError(error => of(new LoadAccountWithTaxScheduleLinksFailure({}))))));
    }
}
AccountWithTaxScheduleLinkEffects.ɵfac = function AccountWithTaxScheduleLinkEffects_Factory(t) { return new (t || AccountWithTaxScheduleLinkEffects)(ɵngcc0.ɵɵinject(ɵngcc8.Actions), ɵngcc0.ɵɵinject(ɵngcc7.AccountService)); };
AccountWithTaxScheduleLinkEffects.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AccountWithTaxScheduleLinkEffects, factory: AccountWithTaxScheduleLinkEffects.ɵfac });
AccountWithTaxScheduleLinkEffects.ctorParameters = () => [
    { type: Actions },
    { type: AccountService }
];
__decorate([
    Effect(),
    __metadata("design:type", Object)
], AccountWithTaxScheduleLinkEffects.prototype, "loadAccountWithTaxScheduleLinks$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmaaDuplicateAccountNumberValidator, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Store }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BmaaDuplicateAccountDescriptionValidator, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.Store }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountLocaleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountNumberFormComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-account-number-form',
                template: "<div [formGroup]=\"addEditAccountForm\" class=\"form-group bmaa-acct-number\" id=\"bmaaAccountNumber\"\n    [ngClass]=\"{'has-error': addEditAccountForm.get(bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(bmaaFormStrings.PATTERN_ERROR) || addEditAccountForm.get(bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(bmaaFormStrings.DUPLICATE_ACCOUNT_NUMBER)}\">\n    <label for=\"accountNumberControl\">\n    {{ 'bmaa_common_accountNumber' | translate}}\n    </label>\n    <input class=\"form-control\" #accountNumberInput maxlength=\"65\" formControlName=\"accountNumberControl\"\n    autofocus [attr.data-qe-id]=\"'bmaa.accountNumber'\" (blur)=\"runNumberDescriptionValidation()\">\n    <div *ngIf=\"addEditAccountForm.get(bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(bmaaFormStrings.PATTERN_ERROR)\" class=\"msg\"\n    translate=\"{{ 'bmaa_common_validCharacters' | translate}}\"></div>\n    <div *ngIf=\"addEditAccountForm.get(bmaaFormStrings.ACCOUNT_NUMBER_CONTROL).hasError(bmaaFormStrings.DUPLICATE_ACCOUNT_NUMBER)\" class=\"msg\"\n    translate=\"{{ 'bmaa_common_duplicateAccountNumber' | translate}}\"></div>\n</div>",
                styles: [".bmaa-acct-number{margin-left:0;margin-right:0}"]
            }]
    }], function () { return [{ type: AccountLocaleService }]; }, { addEditAccountForm: [{
            type: Input
        }], accountNumberInput: [{
            type: ViewChild,
            args: ['accountNumberInput', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountPackagingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountFrpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddAccountModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-add-account-modal',
                template: "<div class=\"bmaa-modal\">\n  <form novalidate [formGroup]=\"addAccountForm\">\n    <button type=\"button\" class=\"close\" aria-hidden=\"true\" (click)=\"cancel()\" [attr.data-qe-id]=\"'bmaa.cancel.top'\">\n      <i class=\"bento-icon-close-x\"></i>\n    </button>\n    <div class=\"modal-header bmaa-header-title\" *ngIf=\"isEquityAccountModal; else addAccountLabel\">\n      {{ 'bmaa_common_addEquityAccount' | translate}}\n    </div>\n    <ng-template #addAccountLabel>\n      <div class=\"modal-header bmaa-header-title\">\n        {{ 'bmaa_common_addAccount' | translate}}\n      </div>\n    </ng-template>\n    <div class=\"modal-body\" #modalBody>\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\" *ngIf=\"addAccountForm.hasError(bmaaFormStrings.NUMBER_DESCRIPTION_REQUIRED_ERROR)\">\n          <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n            <span class=\"bmaa-alert-text\" translate=\"{{ 'bmaa_common_numberDescriptionRequired' | translate}}\"></span>\n          </div>\n        </div>\n\n        <bmaa-account-number-form #accountNumberComponent [addEditAccountForm]=\"addAccountForm\"></bmaa-account-number-form>\n\n        <bmaa-account-description-form [addEditAccountForm]=\"addAccountForm\"></bmaa-account-description-form>\n\n        <bmaa-round-independently-form *ngIf=\"hasStatutoryReportingFrp\"  [addEditAccountForm]=\"addAccountForm\"></bmaa-round-independently-form>\n\n        <div class=\"form-group\">\n          <div class=\"col-md-12\"></div>\n        </div>\n        <div class=\"form-group\" *ngIf=\"hasAnyGroupings\">\n          <span style=\"font-size: 16px;\" translate=\"{{'bmaa_common_groupingAssignments' | translate}}\"></span>\n        </div>\n\n        <!-- Account Classification -->\n        <bmaa-account-grouping-form *ngIf=\"accountClassificationSchedule !== undefined\"\n          [schedule]=\"accountClassificationSchedule\"\n          [modalBodyReference]=\"modalBody\"\n          [optionsObservable]=\"getCategoryNodeOptionsForSchedule(accountClassificationSchedule?.id)\"\n          [addEditAccountForm]=\"addAccountForm\"\n          [balanceOptionFormControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_BALANCE_OPTION_COMBOBOX_CONTROL\"\n          [totalBalanceComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL\"\n          [debitComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_DEBIT_COMBOBOX_CONTROL\"\n          [creditComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_CREDIT_COMBOBOX_CONTROL\"\n        ></bmaa-account-grouping-form>\n\n        <!-- Tax Schedule -->\n        <bmaa-account-grouping-form *ngIf=\"taxSchedule !== undefined\"\n          [schedule]=\"taxSchedule\"\n          [modalBodyReference]=\"modalBody\"\n          [optionsObservable]=\"taxCodeOptionComboboxObservable\"\n          [addEditAccountForm]=\"addAccountForm\"\n          [balanceOptionFormControlName]=\"bmaaFormStrings.TAX_SCHEDULE_BALANCE_OPTION_COMBOBOX_CONTROL\"\n          [totalBalanceComboboxControlName]=\"bmaaFormStrings.TAX_CODE_COMBOBOX_CONTROL\"\n          [debitComboboxControlName]=\"bmaaFormStrings.TAX_CODE_DEBIT_COMBOBOX_CONTROL\"\n          [creditComboboxControlName]=\"bmaaFormStrings.TAX_CODE_CREDIT_COMBOBOX_CONTROL\"\n        ></bmaa-account-grouping-form>\n\n        <!-- User Defined Schedules -->\n        <div *ngFor=\"let schedule of userDefinedSchedules\">\n          <bmaa-account-grouping-form\n            [schedule]=\"schedule\"\n            [modalBodyReference]=\"modalBody\"\n            [optionsObservable]=\"getCategoryNodeOptionsForSchedule(schedule.id)\"\n            [addEditAccountForm]=\"addAccountForm\"\n            [balanceOptionFormControlName]=\"bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule.id)\"\n            [totalBalanceComboboxControlName]=\"bmaaFormStrings.getUserDefinedControl(schedule.id)\"\n            [debitComboboxControlName]=\"bmaaFormStrings.getUserDefinedDebitControl(schedule.id)\"\n            [creditComboboxControlName]=\"bmaaFormStrings.getUserDefinedCreditControl(schedule.id)\"\n          ></bmaa-account-grouping-form>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn btn-primary\" type=\"button\" (click)=\"saveAndClose()\" [disabled]=\"!addAccountForm.valid || (addAccountForm.value.accountNumberControl === '' && addAccountForm.value.accountDescriptionControl === '')\" [attr.data-qe-id]=\"'bmaa.save'\">\n        <span>{{ 'bmaa_addEditAccount_saveClose' | translate}}</span>\n      </button>\n      <button class=\"btn btn-primary\" type=\"button\" (click)=\"saveAddNew()\" [disabled]=\"!addAccountForm.valid || (addAccountForm.value.accountNumberControl === '' && addAccountForm.value.accountDescriptionControl === '')\" [attr.data-qe-id]=\"'bmaa.saveAddNew'\">\n        <span>{{ 'bmaa_addEditAccount_saveAddNew' | translate}}</span>\n      </button>\n      <button class=\"btn btn-default\" type=\"button\" (click)=\"cancel()\" [attr.data-qe-id]=\"'bmaa.cancel'\">\n        <span>{{ 'bmaa_common_cancel' | translate}}</span>\n      </button>\n    </div>\n  </form>\n</div>\n",
                styles: [".bmaa-modal .form-group{margin-left:0;margin-right:0}.bmaa-modal .bmaa-alert-text{margin-left:25px}.bmaa-modal .bmaa-header-title{justify-content:left}"]
            }]
    }], function () { return [{ type: ɵngcc2.FormBuilder }, { type: ɵngcc1.Store }, { type: BmaaDuplicateAccountNumberValidator }, { type: ɵngcc5.NgbActiveModal }, { type: BmaaDuplicateAccountDescriptionValidator }, { type: AccountPackagingService }, { type: AccountFrpService }]; }, { saveAccount: [{
            type: Output
        }], accountNumberComponent: [{
            type: ViewChild,
            args: ['accountNumberComponent', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditAccountModalComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-edit-account-modal',
                template: "<div class=\"bmaa-modal\">\n    <form [formGroup]=\"editAccountForm\">\n        <button type=\"button\" class=\"close\" aria-hidden=\"true\" (click)=\"cancel()\" [attr.data-qe-id]=\"'bmaa.cancel.top'\">\n            <i class=\"bento-icon-close-x\"></i>\n        </button>\n        <div class=\"modal-header bmaa-header-title\">\n            {{ 'bmaa_common_editAccount' | translate}}\n        </div>\n        <div class=\"modal-body\" #modalBody>\n            <div class=\"form-horizontal\">\n                <div class=\"form-group\" *ngIf=\"editAccountForm.hasError(bmaaFormStrings.NUMBER_DESCRIPTION_REQUIRED_ERROR)\">\n                    <div class=\"alert bento-alert alert-danger\" role=\"alert\">\n                      <span class=\"bmaa-alert-text\" translate=\"{{ 'bmaa_common_numberDescriptionRequired' | translate}}\"></span>\n                    </div>\n                  </div>\n\n                <bmaa-account-number-form [addEditAccountForm]=\"editAccountForm\"></bmaa-account-number-form>\n\n                <bmaa-account-description-form [addEditAccountForm]=\"editAccountForm\"></bmaa-account-description-form>\n\n                <bmaa-round-independently-form *ngIf=\"hasStatutoryReportingFrp\" [isEditModal]=\"true\" [addEditAccountForm]=\"editAccountForm\"></bmaa-round-independently-form>\n\n                <div class=\"form-group\">\n                    <div class=\"col-md-12\"></div>\n                </div>\n                <div class=\"form-group\" *ngIf=\"hasAnyGroupings\">\n                    <span style=\"font-size: 16px;\" translate=\"{{'bmaa_common_groupingAssignments' | translate}}\"></span>\n                </div>\n\n                <!-- Account Classification -->\n                <bmaa-account-grouping-form *ngIf=\"accountClassificationSchedule !== undefined\"\n                    [schedule]=\"accountClassificationSchedule\"\n                    [modalBodyReference]=\"modalBody\"\n                    [optionsObservable]=\"getCategoryNodeOptionsForSchedule(accountClassificationSchedule?.id)\"\n                    [addEditAccountForm]=\"editAccountForm\"\n                    [balanceOptionFormControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_BALANCE_OPTION_COMBOBOX_CONTROL\"\n                    [totalBalanceComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL\"\n                    [debitComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_DEBIT_COMBOBOX_CONTROL\"\n                    [creditComboboxControlName]=\"bmaaFormStrings.ACCOUNT_CLASSFICATION_CREDIT_COMBOBOX_CONTROL\">\n                </bmaa-account-grouping-form>\n\n                <!-- Tax Schedule -->\n                <bmaa-account-grouping-form *ngIf=\"taxSchedule !== undefined\"\n                    [schedule]=\"taxSchedule\"\n                    [modalBodyReference]=\"modalBody\"\n                    [optionsObservable]=\"taxCodeOptionComboboxObservable\"\n                    [addEditAccountForm]=\"editAccountForm\"\n                    [balanceOptionFormControlName]=\"bmaaFormStrings.TAX_SCHEDULE_BALANCE_OPTION_COMBOBOX_CONTROL\"\n                    [totalBalanceComboboxControlName]=\"bmaaFormStrings.TAX_CODE_COMBOBOX_CONTROL\"\n                    [debitComboboxControlName]=\"bmaaFormStrings.TAX_CODE_DEBIT_COMBOBOX_CONTROL\"\n                    [creditComboboxControlName]=\"bmaaFormStrings.TAX_CODE_CREDIT_COMBOBOX_CONTROL\">\n                </bmaa-account-grouping-form>\n\n                <!-- User Defined Schedules -->\n                <div *ngFor=\"let schedule of userDefinedSchedules\">\n                    <bmaa-account-grouping-form\n                        [schedule]=\"schedule\"\n                        [modalBodyReference]=\"modalBody\"\n                        [optionsObservable]=\"getCategoryNodeOptionsForSchedule(schedule.id)\"\n                        [addEditAccountForm]=\"editAccountForm\"\n                        [balanceOptionFormControlName]=\"bmaaFormStrings.getUserDefinedTotalBalanceControl(schedule.id)\"\n                        [totalBalanceComboboxControlName]=\"bmaaFormStrings.getUserDefinedControl(schedule.id)\"\n                        [debitComboboxControlName]=\"bmaaFormStrings.getUserDefinedDebitControl(schedule.id)\"\n                        [creditComboboxControlName]=\"bmaaFormStrings.getUserDefinedCreditControl(schedule.id)\">\n                    </bmaa-account-grouping-form>\n                </div>\n            </div>\n        </div>\n        <div class=\"modal-footer\">\n            <button class=\"btn btn-primary\" type=\"button\" (click)=\"saveUpdatedAccount()\"\n                [disabled]=\"!editAccountForm.valid || (editAccountForm.value.accountNumberControl === '' && editAccountForm.value.accountDescriptionControl === '')\"\n                [attr.data-qe-id]=\"'bmaa.save'\">\n                <span>{{ 'bmaa_addEditAccount_saveClose' | translate}}</span>\n            </button>\n            <button class=\"btn btn-default\" type=\"button\" (click)=\"cancel()\" [attr.data-qe-id]=\"'bmaa.cancel'\">\n                <span>{{ 'bmaa_common_cancel' | translate}}</span>\n            </button>\n        </div>\n    </form>\n</div>\n",
                styles: [".bmaa-modal .bmaa-alert-text{margin-left:25px}.bmaa-modal .bmaa-header-title{justify-content:left}"]
            }]
    }], function () { return [{ type: ɵngcc5.NgbActiveModal }, { type: ɵngcc2.FormBuilder }, { type: BmaaDuplicateAccountNumberValidator }, { type: BmaaDuplicateAccountDescriptionValidator }, { type: ɵngcc1.Store }, { type: AccountPackagingService }, { type: AccountFrpService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddAccountComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-add-account',
                template: "<div></div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.Store }, { type: ɵngcc5.NgbModal }, { type: ɵngcc7.AccountService }, { type: ɵngcc7.TrialBalanceService }, { type: AccountLocaleService }, { type: AccountFrpService }]; }, { accountAdded: [{
            type: Output
        }], accountAddedTrialBalance: [{
            type: Output
        }], accountUpdated: [{
            type: Output
        }], accountUpdatedTrialBalance: [{
            type: Output
        }], modalClose: [{
            type: Output
        }], modalCancel: [{
            type: Output
        }], ownerId: [{
            type: Input
        }], passedInData: [{
            type: Input
        }], accountToEdit: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.AccountService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FiscalYearEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.FiscalYearService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PeriodEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.PeriodService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountTagEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.AccountTagService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountGroupEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.AccountGroupService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TaxScheduleEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.TaxScheduleService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TaxCodeMappingOptionEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.TaxCodeService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CategoryNodeMappingOptionEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.CategoryNodeService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountWithAccountGroupLinkEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.AccountService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountWithTaxScheduleLinkEffects, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc8.Actions }, { type: ɵngcc7.AccountService }]; }, null); })();

class AccountGroupingFormComponent {
    constructor(store) {
        this.store = store;
        // Options for the accountGroup comboboxes
        this.categoryNodeOptionsComboboxOptions = {
            labelFormatter: (option) => {
                return `${option.codeOption} | ${option.description}`;
            },
            searchCompare: (row, search) => {
                const searchLowerCase = search.toLocaleLowerCase();
                const name = `${row.codeOption} | ${row.description}`.toLowerCase();
                return name.indexOf(searchLowerCase) > -1;
            },
            searchable: true,
        };
    }
    /**
     * The balance option has changed for the grouping schedule so change combobox values accordingly
     * @param newBalanceOption The new balance option selected in the template
     */
    balanceOptionChanged(newBalanceOption) {
        // If we're moving to total balance and the debit/credit are equal, set total balance to it
        if (newBalanceOption === BmaaBalanceOptions.TotalBalance &&
            this.addEditAccountForm.value[this.debitComboboxControlName]
                === this.addEditAccountForm.value[this.creditComboboxControlName]) {
            this.addEditAccountForm.controls[this.totalBalanceComboboxControlName]
                .setValue(this.addEditAccountForm.value[this.debitComboboxControlName]);
            // If we're moving to total balance and the debit/credit are not equal, set total balance to null
        }
        else if (newBalanceOption === BmaaBalanceOptions.TotalBalance) {
            this.addEditAccountForm.controls[this.totalBalanceComboboxControlName].setValue(null);
            // Moving to debit/credit: Set the debit and credit to the total balance's value
        }
        else {
            this.addEditAccountForm.controls[this.debitComboboxControlName]
                .setValue(this.addEditAccountForm.value[this.totalBalanceComboboxControlName]);
            this.addEditAccountForm.controls[this.creditComboboxControlName]
                .setValue(this.addEditAccountForm.value[this.totalBalanceComboboxControlName]);
        }
    }
    /**
     * Getter of the balance options for use in the HTML
     */
    get bmaaBalanceOption() {
        return BmaaBalanceOptions;
    }
    /**
     * Getter of the balance options for use in the HTML
     */
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    /**
     * Tells us whether or not we are in the accounts application
     */
    isAccountsApplication() {
        return this.applicationType === ApplicationType.Accounts;
    }
    ngOnInit() {
        // Loads the allowDebitCredit from the state
        this.store.pipe(select(getAllowDebitCredit)).subscribe(allowDebCred => {
            this.allowDebitCreditGroupings = allowDebCred;
        });
        // Loads the allowDebitCredit from the state
        this.store.pipe(select(getApplicationType)).subscribe(appType => {
            if (appType) {
                this.applicationType = appType;
            }
        });
        // Loads the defaultFirstGrouping from the state
        this.store.pipe(select(getDefaultFirstGrouping)).subscribe(defGrouping => {
            this.defaultFirstGrouping = defGrouping;
        });
    }
}
AccountGroupingFormComponent.ɵfac = function AccountGroupingFormComponent_Factory(t) { return new (t || AccountGroupingFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store)); };
AccountGroupingFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccountGroupingFormComponent, selectors: [["bmaa-account-grouping-form"]], inputs: { schedule: "schedule", modalBodyReference: "modalBodyReference", optionsObservable: "optionsObservable", addEditAccountForm: "addEditAccountForm", balanceOptionFormControlName: "balanceOptionFormControlName", totalBalanceComboboxControlName: "totalBalanceComboboxControlName", debitComboboxControlName: "debitComboboxControlName", creditComboboxControlName: "creditComboboxControlName" }, decls: 9, vars: 9, consts: [[1, "form-group", 3, "formGroup", "ngClass"], [4, "ngIf"], ["nodeOptionComboboxRow", ""], [1, "row"], [1, "col-md-6"], ["type", "radio", "ng-control", "options", "value", "totalBalance", 1, "bmaa-radio-button", 3, "id", "formControlName", "click"], ["for", "bmaa-total-balance-"], ["type", "radio", "ng-control", "options", "value", "debitCredit", 1, "bmaa-radio-button", 3, "id", "formControlName", "click"], [3, "for"], [3, "required", "appendTo", "options", "placeholder", "itemsObservable", "formControlName", "rowTemplate"], ["class", "msg", 3, "translate", 4, "ngIf"], [1, "msg", 3, "translate"], [1, "table", "table-bordered", "table-striped"], [3, "appendTo", "options", "placeholder", "itemsObservable", "formControlName", "rowTemplate"]], template: function AccountGroupingFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "label");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, AccountGroupingFormComponent_span_3_Template, 3, 3, "span", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, AccountGroupingFormComponent_div_4_Template, 12, 13, "div", 1);
        ɵngcc0.ɵɵtemplate(5, AccountGroupingFormComponent_div_5_Template, 3, 9, "div", 1);
        ɵngcc0.ɵɵtemplate(6, AccountGroupingFormComponent_div_6_Template, 18, 20, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, AccountGroupingFormComponent_ng_template_7_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.addEditAccountForm)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c1, ctx.addEditAccountForm.get(ctx.bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).hasError(ctx.bmaaFormStrings.REQUIRED_ERROR)));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.schedule == null ? null : ctx.schedule.description, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAccountsApplication());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.allowDebitCreditGroupings);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.allowDebitCreditGroupings || ctx.addEditAccountForm.value[ctx.balanceOptionFormControlName] === ctx.bmaaBalanceOption.TotalBalance);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addEditAccountForm.value[ctx.balanceOptionFormControlName] === ctx.bmaaBalanceOption.DebitCredit);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc2.RadioControlValueAccessor, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc6.BentoComboboxComponent, ɵngcc2.RequiredValidator, ɵngcc4.TranslateDirective], pipes: [ɵngcc4.TranslatePipe], styles: [".bmaa-modal tr th{text-transform:none}.bmaa-modal .bmaa-radio-button{margin-right:5px}.bmaa-modal .bui-bento-combobox-container{width:558px!important}.bmaa-modal .form-group{margin-left:0;margin-right:0}"], encapsulation: 2 });
AccountGroupingFormComponent.ctorParameters = () => [
    { type: Store }
];
AccountGroupingFormComponent.propDecorators = {
    schedule: [{ type: Input }],
    modalBodyReference: [{ type: Input }],
    optionsObservable: [{ type: Input }],
    addEditAccountForm: [{ type: Input }],
    balanceOptionFormControlName: [{ type: Input }],
    totalBalanceComboboxControlName: [{ type: Input }],
    debitComboboxControlName: [{ type: Input }],
    creditComboboxControlName: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountGroupingFormComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-account-grouping-form',
                template: "<div class=\"form-group\" [formGroup]=\"addEditAccountForm\" [ngClass]=\"{'has-error': addEditAccountForm.get(bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).hasError(bmaaFormStrings.REQUIRED_ERROR)}\">\n    <label>\n      {{ schedule?.description }}\n      <span *ngIf=\"isAccountsApplication()\">{{ 'bmaa_addEditAccount_categoryStructure' | translate }}</span>\n    </label>\n    <div *ngIf=\"allowDebitCreditGroupings\">\n      <div class=\"row\">\n        <div class=\"col-md-6\">\n          <input type=\"radio\" class=\"bmaa-radio-button\" ng-control=\"options\" value=\"totalBalance\" id=\"bmaa-total-balance-{{schedule.id}}\"\n            formControlName=\"{{balanceOptionFormControlName}}\"\n            (click)=\"balanceOptionChanged(bmaaBalanceOption.TotalBalance)\"\n            [attr.data-qe-id]=\"'bmaa.option.always.' + schedule?.id\"/>\n          <label for=\"bmaa-total-balance-\">\n            {{ 'bmaa_total_balance' | translate }}\n          </label>\n        </div>\n        <div class=\"col-md-6\">\n          <input type=\"radio\" class=\"bmaa-radio-button\" ng-control=\"options\" value=\"debitCredit\" id=\"bmaa-debit-credit-{{schedule.id}}\"\n            formControlName=\"{{balanceOptionFormControlName}}\"\n            (click)=\"balanceOptionChanged(bmaaBalanceOption.DebitCredit)\"\n            [attr.data-qe-id]=\"'bmaa.option.debitCredit.' + schedule?.id\"/>\n          <label for=\"bmaa-debit-credit-{{schedule.id}}\">\n            {{ 'bmaa_assign_debit_credit' | translate }}\n          </label>\n        </div>\n      </div>\n    </div>\n    <div *ngIf=\"!allowDebitCreditGroupings || addEditAccountForm.value[balanceOptionFormControlName] === bmaaBalanceOption.TotalBalance\">\n      <bento-combobox [required]=\"schedule.isStandardAccountClassification && defaultFirstGrouping\" [appendTo]=\"modalBodyReference\"\n        [options]=\"categoryNodeOptionsComboboxOptions\" [placeholder]=\"false\"\n        [itemsObservable]=\"optionsObservable\"\n        formControlName=\"{{totalBalanceComboboxControlName}}\" [rowTemplate]=\"nodeOptionComboboxRow\"\n        [attr.data-qe-id]=\"'bmaa.combo.always.' + schedule?.id\">\n      </bento-combobox>\n      <div *ngIf=\"schedule.isStandardAccountClassification && addEditAccountForm.get(bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).touched && addEditAccountForm.get(bmaaFormStrings.ACCOUNT_CLASSIFICATION_COMBOBOX_CONTROL).hasError(bmaaFormStrings.REQUIRED_ERROR)\"\n        class=\"msg\" translate=\"{{ 'bmaa_common_accountClassRequired' | translate}}\"></div>\n    </div>\n    <div *ngIf=\"addEditAccountForm.value[balanceOptionFormControlName] === bmaaBalanceOption.DebitCredit\">\n      <table class=\"table table-bordered table-striped\">\n        <thead>\n          <tr>\n            <th>\n              <span>{{'bmaa_debit' | translate}}</span>\n            </th>\n            <th>\n              <span>{{'bmaa_credit' | translate}}</span>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr>\n            <td>\n              <bento-combobox [appendTo]=\"modalBodyReference\" [options]=\"categoryNodeOptionsComboboxOptions\" [placeholder]=\"false\"\n                [itemsObservable]=\"optionsObservable\"\n                formControlName=\"{{debitComboboxControlName}}\" [rowTemplate]=\"nodeOptionComboboxRow\"\n                [attr.data-qe-id]=\"'bmaa.combo.debit.' + schedule?.id\">\n              </bento-combobox>\n            </td>\n            <td>\n              <bento-combobox [appendTo]=\"modalBodyReference\" [options]=\"categoryNodeOptionsComboboxOptions\" [placeholder]=\"false\"\n                [itemsObservable]=\"optionsObservable\"\n                formControlName=\"{{creditComboboxControlName}}\"\n                [rowTemplate]=\"nodeOptionComboboxRow\"\n                [attr.data-qe-id]=\"'bmaa.combo.credit.' +  schedule?.id\"></bento-combobox>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n  </div>\n  <ng-template #nodeOptionComboboxRow let-$data=\"data\">\n    <div>\n      {{$data.row.codeOption + ' | ' + $data.row.description}}\n    </div>\n  </ng-template>",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmaa-modal tr th{text-transform:none}.bmaa-modal .bmaa-radio-button{margin-right:5px}.bmaa-modal .bui-bento-combobox-container{width:558px!important}.bmaa-modal .form-group{margin-left:0;margin-right:0}"]
            }]
    }], function () { return [{ type: ɵngcc1.Store }]; }, { schedule: [{
            type: Input
        }], modalBodyReference: [{
            type: Input
        }], optionsObservable: [{
            type: Input
        }], addEditAccountForm: [{
            type: Input
        }], balanceOptionFormControlName: [{
            type: Input
        }], totalBalanceComboboxControlName: [{
            type: Input
        }], debitComboboxControlName: [{
            type: Input
        }], creditComboboxControlName: [{
            type: Input
        }] }); })();

class AccountDescriptionFormComponent {
    constructor() { }
    /**
     * Accesser for BmaaFormStrings for use in the HTML
     */
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    /**
     * We want to manually run the validation on the form because it does not run on blur by default
     */
    runNumberDescriptionValidation() {
        this.addEditAccountForm.updateValueAndValidity();
    }
    ngOnInit() {
    }
}
AccountDescriptionFormComponent.ɵfac = function AccountDescriptionFormComponent_Factory(t) { return new (t || AccountDescriptionFormComponent)(); };
AccountDescriptionFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AccountDescriptionFormComponent, selectors: [["bmaa-account-description-form"]], inputs: { addEditAccountForm: "addEditAccountForm" }, decls: 6, vars: 11, consts: [[1, "form-group", "bmaa-acct-description", 3, "formGroup", "ngClass"], [3, "for"], ["id", "bmaaAccountDescription", "maxlength", "150", 1, "form-control", 3, "formControlName", "blur"], ["class", "msg", 3, "translate", 4, "ngIf"], [1, "msg", 3, "translate"]], template: function AccountDescriptionFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("blur", function AccountDescriptionFormComponent_Template_input_blur_4_listener() { return ctx.runNumberDescriptionValidation(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, AccountDescriptionFormComponent_div_5_Template, 2, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.addEditAccountForm)("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c1, ctx.addEditAccountForm.hasError(ctx.bmaaFormStrings.DUPLICATE_ACCOUNT_DESCRIPTION)));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("for", ctx.bmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 7, "bmaa_common_description"), " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx.bmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.description");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addEditAccountForm.hasError(ctx.bmaaFormStrings.DUPLICATE_ACCOUNT_DESCRIPTION));
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc3.NgClass, ɵngcc2.DefaultValueAccessor, ɵngcc2.MaxLengthValidator, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc3.NgIf, ɵngcc4.TranslateDirective], pipes: [ɵngcc4.TranslatePipe], styles: [".bmaa-acct-description[_ngcontent-%COMP%]{margin-left:0;margin-right:0}"] });
AccountDescriptionFormComponent.ctorParameters = () => [];
AccountDescriptionFormComponent.propDecorators = {
    addEditAccountForm: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccountDescriptionFormComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-account-description-form',
                template: "<div class=\"form-group bmaa-acct-description\" [formGroup]=\"addEditAccountForm\" [ngClass]=\"{ 'has-error': addEditAccountForm.hasError(bmaaFormStrings.DUPLICATE_ACCOUNT_DESCRIPTION)}\">\n    <label for=\"{{bmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL}}\">\n      {{ 'bmaa_common_description' | translate}}\n    </label>\n    <input class=\"form-control\" id=\"bmaaAccountDescription\" maxlength=\"150\"\n      formControlName=\"{{bmaaFormStrings.ACCOUNT_DESCRIPTION_CONTROL}}\" [attr.data-qe-id]=\"'bmaa.description'\" (blur)=\"runNumberDescriptionValidation()\"/>\n    <div *ngIf=\"addEditAccountForm.hasError(bmaaFormStrings.DUPLICATE_ACCOUNT_DESCRIPTION)\" class=\"msg\"\n      translate=\"{{ 'bmaa_common_duplicateAccountDescription' | translate}}\"></div>\n</div>",
                styles: [".bmaa-acct-description{margin-left:0;margin-right:0}"]
            }]
    }], function () { return []; }, { addEditAccountForm: [{
            type: Input
        }] }); })();

class RoundIndependentlyFormComponent {
    constructor(store, frpService) {
        this.store = store;
        this.frpService = frpService;
        this.hasRoundIndependentlyInitialTag = false;
    }
    /**
     * Getter of the form strings for use in the HTML
     */
    get bmaaFormStrings() {
        return BmaaFormStrings;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the roundIndependentlyInitialTag for the edit account
            this.store.pipe(select(getRoundIndependentlyInitialTagForEditAccount), first(accountTag => accountTag !== undefined))
                .toPromise().then(() => {
                this.hasRoundIndependentlyInitialTag = true;
            });
            // Disable roundIndependently toggle for users who don't have RoundIndependentlyAccountsFrp
            const hasRoundIndependentlyAccountsFrp = yield this.frpService.hasRoundIndependentlyAccountsFrp();
            this.roundIndependentlyInput.disabled = !hasRoundIndependentlyAccountsFrp;
        });
    }
    /**
     * return true or false as per the roundIndependently and roundIndependentlyInitial value
     */
    displayWarningMessage() {
        const roundIndependentlyValue = this.addEditAccountForm.get('roundIndependentlyControl').value;
        return (!this.hasRoundIndependentlyInitialTag && roundIndependentlyValue) ||
            (this.hasRoundIndependentlyInitialTag && !roundIndependentlyValue);
    }
}
RoundIndependentlyFormComponent.ɵfac = function RoundIndependentlyFormComponent_Factory(t) { return new (t || RoundIndependentlyFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Store), ɵngcc0.ɵɵdirectiveInject(AccountFrpService)); };
RoundIndependentlyFormComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RoundIndependentlyFormComponent, selectors: [["bmaa-round-independently-form"]], viewQuery: function RoundIndependentlyFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.roundIndependentlyInput = _t.first);
    } }, inputs: { addEditAccountForm: "addEditAccountForm", isEditModal: "isEditModal" }, decls: 11, vars: 12, consts: [[1, "form-group", 3, "formGroup"], [3, "for"], ["tooltipClass", "bmaa-tooltip-custom", 1, "bento-icon-info-filled", "bmaa-tooltip-custom-class", 3, "ngbTooltip"], [1, "row"], [1, "col-md-2"], [3, "formControlName"], ["roundIndependentlyInput", ""], [4, "ngIf"], [1, "badge", "badge-warning", "bmaa-warning-badge-class"], [1, "bmaa-warning-msg-class"]], template: function RoundIndependentlyFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementStart(6, "div", 3)(7, "div", 4);
        ɵngcc0.ɵɵelement(8, "bento-toggle", 5, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, RoundIndependentlyFormComponent_div_10_Template, 6, 3, "div", 7);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.addEditAccountForm);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("for", ctx.bmaaFormStrings.ROUND_INDEPENDENTLY_CONTROL);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 8, "bmaa_roundIndependently"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("ngbTooltip", ɵngcc0.ɵɵpipeBind1(5, 10, "bmaa_roundIndependently_info"));
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.tooltip.info");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("formControlName", ctx.bmaaFormStrings.ROUND_INDEPENDENTLY_CONTROL);
        ɵngcc0.ɵɵattribute("data-qe-id", "bmaa.roundIndependently.toggle");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayWarningMessage() && ctx.isEditModal);
    } }, directives: [ɵngcc2.NgControlStatusGroup, ɵngcc2.FormGroupDirective, ɵngcc5.NgbTooltip, ɵngcc6.BentoNgbTooltipSupportDirective, ɵngcc6.BentoToggleComponent, ɵngcc2.NgControlStatus, ɵngcc2.FormControlName, ɵngcc3.NgIf], pipes: [ɵngcc4.TranslatePipe], styles: [".bmaa-tooltip-custom-class{font-size:16px;font-weight:700;margin-left:5px}.bmaa-warning-badge-class{margin-left:-30px}.bmaa-warning-msg-class{margin-left:5px}.bmaa-tooltip-custom .tooltip-inner{box-shadow:none!important;text-align:left}"], encapsulation: 2 });
RoundIndependentlyFormComponent.ctorParameters = () => [
    { type: Store },
    { type: AccountFrpService }
];
RoundIndependentlyFormComponent.propDecorators = {
    addEditAccountForm: [{ type: Input }],
    isEditModal: [{ type: Input }],
    roundIndependentlyInput: [{ type: ViewChild, args: ['roundIndependentlyInput', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RoundIndependentlyFormComponent, [{
        type: Component,
        args: [{
                selector: 'bmaa-round-independently-form',
                template: "<div [formGroup]=\"addEditAccountForm\" class=\"form-group\">\n  <label for=\"{{bmaaFormStrings.ROUND_INDEPENDENTLY_CONTROL}}\">{{'bmaa_roundIndependently'  | translate }}</label>\n  <i ngbTooltip=\"{{'bmaa_roundIndependently_info'  | translate }}\" [attr.data-qe-id]=\"'bmaa.tooltip.info'\"\n    tooltipClass=\"bmaa-tooltip-custom\" class=\"bento-icon-info-filled bmaa-tooltip-custom-class\"></i>\n  <div class=\"row\">\n    <div class=\"col-md-2\">\n      <bento-toggle #roundIndependentlyInput [attr.data-qe-id]=\"'bmaa.roundIndependently.toggle'\"\n        formControlName=\"{{bmaaFormStrings.ROUND_INDEPENDENTLY_CONTROL}}\"></bento-toggle>\n    </div>\n    <div *ngIf=\"displayWarningMessage() && isEditModal\">\n      <span class=\"badge badge-warning bmaa-warning-badge-class\">Warning</span>\n      <span class=\"bmaa-warning-msg-class\">{{'bmaa_roundIndependently_msg'  | translate }}</span>\n    </div>\n  </div>\n</div>",
                encapsulation: ViewEncapsulation.None,
                styles: [".bmaa-tooltip-custom-class{font-size:16px;font-weight:700;margin-left:5px}.bmaa-warning-badge-class{margin-left:-30px}.bmaa-warning-msg-class{margin-left:5px}.bmaa-tooltip-custom .tooltip-inner{box-shadow:none!important;text-align:left}"]
            }]
    }], function () { return [{ type: ɵngcc1.Store }, { type: AccountFrpService }]; }, { addEditAccountForm: [{
            type: Input
        }], isEditModal: [{
            type: Input
        }], roundIndependentlyInput: [{
            type: ViewChild,
            args: ['roundIndependentlyInput', { static: true }]
        }] }); })();

class AddAccountModule {
}
AddAccountModule.ɵfac = function AddAccountModule_Factory(t) { return new (t || AddAccountModule)(); };
AddAccountModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AddAccountModule });
AddAccountModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [BmaaDuplicateAccountNumberValidator, BmaaDuplicateAccountDescriptionValidator], imports: [[
            StoreModule.forFeature(StoreSelectorNames.ADD_ACCOUNT, reducers, { metaReducers: metaReducers }),
            EffectsModule.forFeature([AccountEffects, AccountGroupEffects, TaxScheduleEffects,
                TaxCodeMappingOptionEffects, CategoryNodeMappingOptionEffects, AccountWithAccountGroupLinkEffects,
                AccountWithTaxScheduleLinkEffects, FiscalYearEffects, PeriodEffects, AccountTagEffects]),
            AccountingServicesModule,
            NgbModule,
            TranslateModule.forChild(),
            FormsModule,
            CommonModule,
            ReactiveFormsModule,
            BentoModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AddAccountModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AddAccountComponent,
                    AddAccountModalComponent,
                    AccountGroupingFormComponent,
                    AccountDescriptionFormComponent,
                    AccountNumberFormComponent,
                    EditAccountModalComponent,
                    RoundIndependentlyFormComponent
                ],
                imports: [
                    StoreModule.forFeature(StoreSelectorNames.ADD_ACCOUNT, reducers, { metaReducers: metaReducers }),
                    EffectsModule.forFeature([AccountEffects, AccountGroupEffects, TaxScheduleEffects,
                        TaxCodeMappingOptionEffects, CategoryNodeMappingOptionEffects, AccountWithAccountGroupLinkEffects,
                        AccountWithTaxScheduleLinkEffects, FiscalYearEffects, PeriodEffects, AccountTagEffects]),
                    AccountingServicesModule,
                    NgbModule,
                    TranslateModule.forChild(),
                    FormsModule,
                    CommonModule,
                    ReactiveFormsModule,
                    BentoModule
                ],
                providers: [BmaaDuplicateAccountNumberValidator, BmaaDuplicateAccountDescriptionValidator],
                exports: [AddAccountComponent],
                entryComponents: [AddAccountModalComponent, AddAccountComponent, EditAccountModalComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AddAccountModule, { declarations: function () { return [AddAccountComponent, AddAccountModalComponent, AccountGroupingFormComponent, AccountDescriptionFormComponent, AccountNumberFormComponent, EditAccountModalComponent, RoundIndependentlyFormComponent]; }, imports: function () { return [ɵngcc1.StoreFeatureModule, ɵngcc8.EffectsFeatureModule, AccountingServicesModule,
        NgbModule, ɵngcc4.TranslateModule, FormsModule,
        CommonModule,
        ReactiveFormsModule,
        BentoModule]; }, exports: function () { return [AddAccountComponent]; } }); })();

/*
 * Public API Surface of add-account
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddAccountComponent, AddAccountModule, AccountLocaleService as ɵb, reducer$9 as ɵba, reducer$a as ɵbb, AccountEffects as ɵbc, AccountGroupEffects as ɵbe, TaxScheduleEffects as ɵbg, TaxCodeMappingOptionEffects as ɵbi, CategoryNodeMappingOptionEffects as ɵbk, AccountWithAccountGroupLinkEffects as ɵbm, AccountWithTaxScheduleLinkEffects as ɵbo, FiscalYearEffects as ɵbq, PeriodEffects as ɵbs, AccountTagEffects as ɵbu, AccountFrpService as ɵc, AddAccountModalComponent as ɵd, BmaaDuplicateAccountNumberValidator as ɵe, reducer as ɵg, BmaaDuplicateAccountDescriptionValidator as ɵh, AccountPackagingService as ɵi, AccountGroupingFormComponent as ɵj, AccountDescriptionFormComponent as ɵk, AccountNumberFormComponent as ɵl, EditAccountModalComponent as ɵm, RoundIndependentlyFormComponent as ɵn, StoreSelectorNames as ɵo, reducers as ɵp, clearState as ɵq, metaReducers as ɵr, reducer$1 as ɵs, reducer$2 as ɵt, reducer$3 as ɵu, reducer$4 as ɵv, reducer$5 as ɵw, reducer$6 as ɵx, reducer$7 as ɵy, reducer$8 as ɵz };

